//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { ADMIN_API_BASE_URL } from '../http/api-client.tokens';

export interface IClient {
  /**
   * Retrieves every action entitlement group record.
   *
   * @returns Returns the list of action entitlement groups.
   */
  actionEntitlementGroupsAll(): Observable<ActionEntitlementGroupResponse[]>;
  /**
   * Creates a new action entitlement group record.
   *
   * @param body (optional) The create request payload to persist.
   * @returns No Content
   */
  actionEntitlementGroupsPOST(body?: ActionEntitlementGroupCreateRequest | undefined): Observable<void>;
  /**
   * Retrieves a single action entitlement group by its integer primary key.
   *
   * @param id The unique group identifier.
   * @returns Returns the requested group.
   */
  actionEntitlementGroupsGET(id: number): Observable<ActionEntitlementGroupResponse>;
  /**
   * Retrieves every action entitlement record from the database.
   *
   * @returns Returns the list of action entitlements.
   */
  actionEntitlementsAll(): Observable<ActionEntitlementResponse[]>;
  /**
   * Creates a new action entitlement record.
   *
   * @param body (optional) The create request payload to persist.
   * @returns No Content
   */
  actionEntitlementsPOST(body?: ActionEntitlementCreateRequest | undefined): Observable<void>;
  /**
   * Retrieves a single action entitlement by its string code primary key.
   *
   * @param code The unique entitlement code (e.g. `"VIEW_USERS"`).
   * @returns Returns the requested action entitlement.
   */
  actionEntitlementsGET(code: string): Observable<ActionEntitlementResponse>;
  /**
   * Deletes an action entitlement by its string code.
   *
   * @param code The unique entitlement code to delete.
   * @returns The action entitlement was deleted.
   */
  actionEntitlementsDELETE(code: string): Observable<void>;
  /**
   * Searches activity logs with filtering, search, sorting, and pagination.
   *
   * @param body (optional) The search request containing filters, pagination, and search/sort parameters.
   * @returns Returns the paginated list of activity logs.
   */
  search(body?: ActivityLogFilterRequest | undefined): Observable<ActivityLogResponsePagedResult>;
  /**
   * Retrieves all activity event types for use in filters and dropdowns.
   *
   * @param includeDeleted (optional) If true, includes deleted event types. Default is false.
   * @returns Returns the list of activity event types.
   */
  eventtypes(includeDeleted?: boolean | undefined): Observable<ActivityEventTypeResponse[]>;
  /**
   * Retrieves all entity types for use in filters and dropdowns.
   *
   * @param includeDeleted (optional) If true, includes deleted entity types. Default is false.
   * @returns Returns the list of entity types.
   */
  entitytypes(includeDeleted?: boolean | undefined): Observable<EntityTypeResponse[]>;
  /**
   * Retrieves all modules for use in filters and dropdowns.
   *
   * @param includeDeleted (optional) If true, includes deleted modules. Default is false.
   * @returns Returns the list of modules.
   */
  modules(includeDeleted?: boolean | undefined): Observable<ModuleResponse[]>;
  /**
   * Retrieves all step/event detail rows for a specific activity log entry, ordered by `SequenceNo`. Data is read
   * from `[ADMIN].[ActivityLogDetails]`.
   *
   * @param activityLogId The unique identifier of the parent activity log entry.
   * @returns Returns the ordered list of activity log detail rows.
   */
  details(activityLogId: number): Observable<ActivityLogDetailResponse[]>;
  /**
   * Logs an administrative activity from external services (e.g., login/logout events). Accepts string-based
   * codes/names and converts them to enum types internally.
   *
   * @param body (optional) The activity log request with string-based lookup values.
   * @returns Returns true if the activity was successfully logged, false otherwise.
   */
  activityLogs(body?: CreateActivityLogRequest | undefined): Observable<boolean>;
  /**
   * Logs a batch of administrative activities in a single request. Intended for high-volume event sources that buffer
   * locally and flush in groups of 50.
   *
   * @param body (optional)
   * @returns OK
   */
  batch(body?: CreateActivityLogRequest[] | undefined): Observable<boolean>;
  /**
   * Exports all activity logs matching the filter as a downloadable CSV file. Rows are streamed directly from
   * `SqlDataReader` to the HTTP response body â€” server RAM usage is O(1) per request regardless of record count,
   * safe for 10 lakh+ records. A date range (`FromDate` and `ToDate`) is strongly recommended.
   *
   * @param body (optional) Filter criteria. Pagination fields are ignored.
   * @returns Streams a `text/csv` file containing the exported logs.
   */
  export(body?: ActivityLogFilterRequest | undefined): Observable<void>;
  /**
   * Retrieves all clients with their lines of business and intervention types.
   *
   * @param includeInactive (optional) Optional. Whether to include inactive clients. Default is false.
   * @returns Returns the list of clients.
   */
  clientsAll(includeInactive?: boolean | undefined): Observable<ClientManagementResponse[]>;
  /**
   * Onboards a client from CODIS to the main Client table with associated configurations. Creates a Client record and
   * cross-joined ClientConfig records for all LOB and intervention type combinations.
   *
   * @param body (optional) The add client request containing client ID, LOB IDs, and intervention type IDs.
   * @returns No Content
   */
  clientsPOST(body?: AddClientRequest | undefined): Observable<void>;
  /**
   * Retrieves a paginated, filtered, and sorted list of clients. Supports server-side paging, sorting, free-text
   * search, and filtering.
   *
   * @param body (optional) Paged search request containing filter, sort, and pagination parameters.
   * @returns OK
   */
  search2(body?: ClientListRequest | undefined): Observable<ClientManagementResponsePagedResult>;
  /**
   * Retrieves detailed client information by client row ID including name, LOBs, and intervention types.
   *
   * @param clientId The client row identifier (surrogate key).
   * @returns Returns the requested client details.
   */
  clientsGET(clientId: number): Observable<ClientManagementData>;
  /**
   * Retrieves clients from CODIS that have not yet been onboarded to the main Client table. Used for populating
   * onboarding dropdowns with available clients.
   *
   * @returns Returns the list of unonboarded clients.
   */
  unonboardedClients(): Observable<UnonboardedClientResponse[]>;
  /**
   * Triggers the Azure DevOps onboarding pipeline for a client.
   *
   * @param clientId The client identifier.
   * @param body (optional) The pipeline trigger request.
   * @returns Pipeline trigger submitted.
   */
  pipeline(
    clientId: number,
    body?: TriggerClientOnboardingRequest | undefined
  ): Observable<TriggerClientOnboardingResponse>;
  /**
   * Updates a client's LOB and intervention type configurations. Deletes all existing ClientConfig records and
   * creates new ones based on the cross join of provided LOBs and interventions.
   *
   * @param clientId The client row identifier.
   * @param body (optional) The update request containing LOB IDs and intervention type IDs.
   * @returns Configurations successfully updated.
   */
  configurations(
    clientId: number,
    body?: UpdateClientConfigurationRequest | undefined
  ): Observable<UpdateClientConfigurationResponse>;
  /**
   * Deactivates a client by setting its IsActive flag to false. The client will be excluded from all active client
   * queries and multi-tenancy resolution.
   *
   * @param clientId The business client identifier.
   * @returns Client successfully deactivated.
   */
  deactivate(clientId: number): Observable<DeactivateClientResponse>;
  /**
   * Retrieves all client-specific templates from the client template configuration table. Returns template name,
   * version, line of business, intervention type, effective dates, and assigned by information.
   *
   * @param clientId (optional) Optional. Filter templates by specific client ID.
   * @returns Returns the list of client-specific templates.
   */
  clientTemplates(clientId?: number | undefined): Observable<ClientSpecificTemplateResponse[]>;
  /** @returns OK */
  health(): Observable<void>;
  /** @returns OK */
  detailed(): Observable<HealthCheckResponse>;
  /**
   * Starts an impersonation session by obtaining a JWT token for the specified user. Requires the `User.SimulateUser`
   * permission.
   *
   * @param body (optional) The impersonation start request containing the user email to impersonate.
   * @returns Returns the JWT token for successful impersonation.
   */
  token(body?: ImpersonationStartRequest | undefined): Observable<ImpersonationStartResponse>;
  /**
   * Stops an impersonation session by invalidating the token for the specified user. Requires the `User.SimulateUser`
   * permission.
   *
   * @param body (optional) The impersonation stop request containing the user email and token ID.
   * @returns Returns success if the impersonation session was stopped.
   */
  logout(body?: ImpersonationStopRequest | undefined): Observable<ImpersonationStopResponse>;
  /**
   * Sets the offline PIN for the authenticated nurse practitioner.
   *
   * @param body (optional) Request containing the PIN to set.
   * @returns PIN set successfully.
   */
  pinPOST(body?: SetNursePractitionerPinRequest | undefined): Observable<NursePractitionerPinResponse>;
  /**
   * Gets the offline PIN for the authenticated nurse practitioner.
   *
   * @returns PIN retrieved successfully.
   */
  pinGET(): Observable<NursePractitionerPinResponse>;
  /**
   * Gets all active published release notes for a specific date. Returns all active releases without user-specific
   * filtering. Client applications filter dismissed releases using browser storage.
   *
   * @param date (optional) The date to check for active release notes. Defaults to current date.
   * @returns Returns the list of active release notes.
   */
  active(date?: string | undefined): Observable<ActiveReleaseNoteResponse[]>;
  /**
   * Gets all published release notes for timeline view (past releases).
   *
   * @param fromDate (optional) Optional timestamp to filter release notes with StartDate <= fromDate. If not
   *   provided, defaults to the current UTC time.
   * @returns Returns the list of published releases.
   */
  published(fromDate?: string | undefined): Observable<ReleaseNoteTimelineResponse[]>;
  /**
   * Gets all published release notes with full details (including items).
   *
   * @param fromDate (optional) Optional date to filter release notes with StartDate <= fromDate. If not provided,
   *   defaults to today.
   * @returns Returns the list of published releases with full details.
   */
  viewAll(fromDate?: string | undefined): Observable<ReleaseNoteViewResponse[]>;
  /**
   * Gets full release note details for viewing (used in "View summary" link).
   *
   * @param id The unique identifier of the release note.
   * @param fromDate (optional) Optional date to filter release notes with StartDate <= fromDate. If not provided,
   *   defaults to today.
   * @returns Returns the release note for viewing.
   */
  view(id: number, fromDate?: string | undefined): Observable<ReleaseNoteViewResponse>;
  /**
   * Retrieves all release notes with pagination (admin history grid).
   *
   * @param offset (optional) Number of records to skip. Default is 0.
   * @param limit (optional) Maximum number of records to return. Must be between 1 and 100. Default is 50.
   * @returns Returns the paginated list of release notes.
   */
  releaseNotesManagementGET(
    offset?: number | undefined,
    limit?: number | undefined
  ): Observable<ReleaseNoteResponsePagedResult>;
  /**
   * Creates a new release note as Draft or Published.
   *
   * @param body (optional) The release note creation request.
   * @returns No Content
   */
  releaseNotesManagementPOST(body?: CreateReleaseNoteRequest | undefined): Observable<void>;
  /**
   * Searches release notes with pagination, filtering, and sorting (admin management grid).
   *
   * @param body (optional) Search request with pagination, free-text search, column selection, and sorting.
   * @returns Returns the paginated list of release notes.
   */
  releaseNotesSearch(body?: ReleaseNoteSearchRequest | undefined): Observable<ReleaseNoteResponsePagedResult>;
  /**
   * Retrieves a release note by ID with full details and change history.
   *
   * @param id The unique identifier of the release note.
   * @returns Returns the release note details.
   */
  releaseNotesManagementGET2(id: number): Observable<ReleaseNoteResponse>;
  /**
   * Updates an existing release note.
   *
   * @param id The unique identifier of the release note to update.
   * @param body (optional) The updated release note data.
   * @returns Release note updated successfully.
   */
  releaseNotesManagementPUT(id: number, body?: UpdateReleaseNoteRequest | undefined): Observable<ReleaseNoteResponse>;
  /**
   * Soft deletes a release note (sets IsDeleted flag).
   *
   * @param id The unique identifier of the release note to delete.
   * @returns Release note deleted successfully.
   */
  releaseNotesManagementDELETE(id: number): Observable<any>;
  /**
   * Publishes a draft release note, making it active during the configured date range.
   *
   * @param id The unique identifier of the release note to publish.
   * @returns Release note published successfully.
   */
  publish(id: number): Observable<ReleaseNoteResponse>;
  /**
   * Retrieves all role-action entitlement mappings for the specified role.
   *
   * @param roleId The role identifier to filter by.
   * @returns Returns the list of role-entitlement assignments.
   */
  actionEntitlementsAll2(roleId: number): Observable<RoleActionEntitlementResponse[]>;
  /**
   * Synchronizes a role's action entitlements. Removes action entitlements not in the payload and adds new ones.
   * Existing assignments that match are kept intact.
   *
   * @param roleId The role identifier from the route.
   * @param body (optional) The sync request containing the desired permission codes.
   * @returns The role's action entitlements were synchronized successfully.
   */
  actionEntitlementsPUT(roleId: number, body?: SyncRoleActionEntitlementsRequest | undefined): Observable<void>;
  /**
   * Assigns an action entitlement to a role by creating a mapping row.
   *
   * @param body (optional) The request payload containing the role and entitlement identifiers.
   * @returns No Content
   */
  actionEntitlementsPOST2(body?: RoleActionEntitlementCreateRequest | undefined): Observable<void>;
  /**
   * Removes a role-action entitlement assignment by its mapping row identifier.
   *
   * @param id The primary key of the role-action entitlement mapping to remove.
   * @returns The assignment was removed.
   */
  actionEntitlementsDELETE2(id: number): Observable<void>;
  /**
   * Retrieves every role as a Response with user counts.
   *
   * @returns Returns the list of roles.
   */
  rolesAllGET(): Observable<RoleResponse[]>;
  /**
   * Creates a new role record.
   *
   * @param body (optional) The create request payload. Model binding reads the JSON request body.
   * @returns No Content
   */
  rolesPOST(body?: RoleCreateRequest | undefined): Observable<void>;
  /**
   * Retrieves a single role as a Response by its integer primary key.
   *
   * @param id The unique identifier of the role.
   * @returns Returns the requested role.
   */
  rolesGET(id: number): Observable<RoleResponse>;
  /**
   * Updates an existing role. The route id must match Admin.Models.Request.RoleUpdateRequest.Id in the request body;
   * otherwise a `400 Bad Request` is returned.
   *
   * @param id The role identifier from the route.
   * @param body (optional) The updated role payload from the JSON request body.
   * @returns The role was updated successfully.
   */
  rolesPUT(id: number, body?: RoleUpdateRequest | undefined): Observable<void>;
  /**
   * Deletes a role by its integer primary key.
   *
   * @param id The unique identifier of the role to delete.
   * @returns The role was deleted successfully.
   */
  rolesDELETE(id: number): Observable<void>;
  /**
   * Synchronizes a role's user assignments. Removes users not in the payload and adds new ones. Existing assignments
   * that match are kept intact.
   *
   * @param roleId The role identifier from the route.
   * @param body (optional) The sync request containing the desired user IDs.
   * @returns The role's user assignments were synchronized successfully.
   */
  usersPUT(roleId: number, body?: SyncRoleUsersRequest | undefined): Observable<void>;
  /**
   * Retrieves all permissions organized in a hierarchical structure by groups. Parent groups contain child groups;
   * leaf groups contain permissions with assignment status. Use this endpoint for UI to display a tree view of
   * permissions.
   *
   * @param roleId The role identifier from the route.
   * @returns Returns the hierarchical permissions matrix.
   */
  permissionsMatrixHierarchical(roleId: number): Observable<PermissionGroupNodeResponse[]>;
  /**
   * Searches rule groups with pagination, filtering, and sorting.
   *
   * @param body (optional) Paged search request.
   * @returns OK
   */
  search3(body?: RuleGroupSearchRequest | undefined): Observable<RuleGroupResponsePagedResult>;
  /**
   * Gets rule groups that contain at least one rule matching the given categories, without pagination.
   *
   * @param categoryIds (optional) Comma-separated category identifiers used to filter matching rule groups.
   * @param isActive (optional) Optional active status filter.
   * @returns OK
   */
  ruleGroupsByCategory(
    categoryIds?: string | undefined,
    isActive?: boolean | undefined
  ): Observable<RuleGroupResponse[]>;
  /**
   * Gets a rule group by identifier including its rules.
   *
   * @param id Rule group identifier.
   * @returns OK
   */
  ruleGroupsGET(id: number): Observable<RuleGroupDetailResponse>;
  /**
   * Updates an existing rule group.
   *
   * @param id Rule group identifier.
   * @param body (optional) Update request payload.
   * @returns No Content
   */
  ruleGroupsPUT(id: number, body?: UpdateRuleGroupRequest | undefined): Observable<void>;
  /**
   * Deletes a rule group.
   *
   * @param id Rule group identifier.
   * @returns No Content
   */
  ruleGroupsDELETE(id: number): Observable<void>;
  /**
   * Creates a new rule group.
   *
   * @param body (optional) Create request payload.
   * @returns No Content
   */
  ruleGroupsPOST(body?: CreateRuleGroupRequest | undefined): Observable<void>;
  /**
   * Activates or deactivates an existing rule group.
   *
   * @param id Rule group identifier.
   * @param body (optional) Status update request payload.
   * @returns No Content
   */
  activateDeactivate(id: number, body?: ActivateDeactivateRuleGroupRequest | undefined): Observable<void>;
  /**
   * Searches rules with pagination, filtering, and sorting.
   *
   * @param body (optional) Paged search request.
   * @returns OK
   */
  search4(body?: RuleQueryRequest | undefined): Observable<RuleDetailResponsePagedResult>;
  /**
   * Gets all rules for the specified rule group.
   *
   * @param ruleGroupId (optional) Parent rule-group identifier.
   * @param categoryIds (optional) Optional category identifiers used to filter the returned rules.
   * @returns OK
   */
  rulesAll(ruleGroupId?: number | undefined, categoryIds?: string | undefined): Observable<RuleDetailResponse[]>;
  /**
   * Creates a new rule.
   *
   * @param body (optional) Create request payload.
   * @returns No Content
   */
  rulesPOST(body?: CreateRuleRequest | undefined): Observable<void>;
  /**
   * Gets details for a single rule.
   *
   * @param id Rule identifier.
   * @returns OK
   */
  rulesGET(id: number): Observable<RuleDetailResponse>;
  /**
   * Deletes a rule.
   *
   * @param id Rule identifier.
   * @returns No Content
   */
  rulesDELETE(id: number): Observable<void>;
  /**
   * Activates or deactivates an existing rule.
   *
   * @param id Rule identifier.
   * @param body (optional) Status update request payload.
   * @returns No Content
   */
  activateDeactivate2(id: number, body?: ActivateDeactivateRuleRequest | undefined): Observable<void>;
  /**
   * Retrieves a denormalized list of all user details including their associated metadata.
   *
   * @returns Returns the user details data.
   */
  userDetails(): Observable<UserDetailResponse[]>;
  /**
   * Retrieves user details for a specific user.
   *
   * @param userId The user identifier to filter by.
   * @returns Returns the user detail data for the specified user.
   */
  userDetails2(userId: number): Observable<UserDetailByIdResponse[]>;
  /**
   * Retrieves user roles details for a specific user including application and entitlement information.
   *
   * @param userId The user identifier to filter by.
   * @returns Returns the user roles detail data for the specified user.
   */
  userRoles(userId: number): Observable<UserRolesDetailByIdResponse[]>;
  /**
   * Retrieves all users belonging to the configured application.
   *
   * @returns Returns the list of users.
   */
  usersAll(): Observable<UmUserResponse[]>;
  /**
   * Creates a new User.Domain.Entities.UserManagement.UmUser record and synchronizes to Central database. If
   * UserTypeId = 1, also creates a practitioner record.
   *
   * @param body (optional) The user data to persist. Model binding reads the JSON request body.
   * @returns The user was created successfully.
   */
  usersPOST(body?: UserCreateRequest | undefined): Observable<UserCreateResponse>;
  /**
   * Retrieves users filtered by one or more user type IDs.
   *
   * @param body (optional) Comma-separated list of user type IDs to filter by (e.g., "1,2,3").
   * @returns Returns the filtered list of users.
   */
  userTypesIds(body?: number[] | undefined): Observable<UserResponse[]>;
  /**
   * Retrieves users of a specific vendor and filtered by one or more user type IDs
   *
   * @param body (optional) The vendor and user type identifiers to filter by.
   * @returns Returns the filtered list of users.
   */
  userTypesIds2(body?: VendorUsersByTypeRequest | undefined): Observable<UserResponse[]>;
  /**
   * Retrieves all active users for the logged-in user's vendor(s) from the Central database. Automatically scoped to
   * the current user's vendors via IApplicationContext.VendorIds from JWT. Returns results in UserSearchResponse
   * format (UserId, UserName, EmailAddress, UserTypeId). Useful for dropdown filters and user selection lists.
   *
   * @returns Returns the list of active users for the logged-in user's vendor(s).
   */
  vendorUsers(): Observable<UserSearchResponse[]>;
  /**
   * Retrieves a single user by its integer primary key, if they belong to the configured application.
   *
   * @param id The unique identifier of the user.
   * @returns Returns the requested user.
   */
  usersGET(id: number): Observable<UserResponse>;
  /**
   * Updates an existing user. The route id must match Admin.Models.Request.UserUpdateRequest.Id in the request body;
   * otherwise a `400 Bad Request` is returned.
   *
   * @param id The user identifier from the route.
   * @param body (optional) The updated user payload from the JSON request body.
   * @returns The user was updated successfully.
   */
  usersPUT2(id: number, body?: UserUpdateRequest | undefined): Observable<void>;
  /**
   * Retrieves salt key for the specified user.
   *
   * @param id The unique identifier of the user.
   * @returns Returns the requested salt key.
   */
  saltKey(id: number): Observable<string>;
  /**
   * Checks whether a user with the specified email address already exists.
   *
   * @param email The email address to check.
   * @returns Returns true if the email exists, false otherwise.
   */
  emailExists(email: string): Observable<boolean>;
  /**
   * Activates user by userId.
   *
   * @param id The user identifier from the route.
   * @returns No Content
   */
  activate(id: number): Observable<void>;
  /**
   * Bulk deactivates multiple users in an optimized batch operation. Orchestrates user deactivation across
   * UserManagement, Central, and Practitioner services. Implements continue-on-error strategy with detailed failure
   * tracking. Maximum 500 users per request.
   *
   * @param body (optional) The bulk deactivate request containing user IDs (max 500).
   * @returns Bulk deactivation completed (with or without individual failures).
   */
  bulkDeactivate(body?: BulkDeactivateUsersRequest | undefined): Observable<BulkDeactivateUsersResponse>;
  /**
   * Retrieves all user-action entitlement mappings for the specified user.
   *
   * @param userId The user identifier to filter by.
   * @returns Returns the list of user-entitlement assignments.
   */
  actionEntitlementsAll3(userId: number): Observable<UserActionEntitlementResponse[]>;
  /**
   * Assigns an action entitlement directly to a user by creating a mapping row.
   *
   * @param body (optional) The request payload containing the user and entitlement identifiers.
   * @returns No Content
   */
  actionEntitlementsPOST3(body?: UserActionEntitlementCreateRequest | undefined): Observable<void>;
  /**
   * Retrieves all user-role mappings for the specified user.
   *
   * @param userId The user identifier to filter by.
   * @returns Returns the list of role assignments for the user.
   */
  rolesAllGET2(userId: number): Observable<UserRoleResponse[]>;
  /**
   * Synchronizes (replaces) all role assignments for a user. Removes roles not in the provided list and adds new
   * ones. This is an idempotent operation.
   *
   * @param userId The user identifier from the route.
   * @param body (optional) The complete list of role IDs to assign to the user.
   * @returns Returns the updated list of user roles.
   */
  rolesAllPUT(userId: number, body?: number[] | undefined): Observable<UserRoleResponse[]>;
  /**
   * Assigns a role to a user by creating a mapping row.
   *
   * @param body (optional) The request payload containing the user and role identifiers.
   * @returns No Content
   */
  rolesPOST2(body?: UserRoleCreateRequest | undefined): Observable<void>;
  /**
   * Executes the `[dbo].[usp_Get_Users]` stored procedure with server-side paging, search, sort, and optional
   * client/application filters. Returns both the result set and the total matching row count for pagination
   * metadata.
   *
   * @param body (optional) The paged/filtered request body containing page, page size, search, sort, client and
   *   application filters.
   * @returns Returns the paged user list with pagination metadata.
   */
  search5(body?: GetUsersRequest | undefined): Observable<GetUsersResultResponsePagedResult>;
  /**
   * Executes the `[dbo].[usp_Get_User_Action_Entitlements]` stored procedure for a given user and application
   * combination.
   *
   * @param userId The user identifier passed as `@Ip_UserId`.
   * @param applicationId The application identifier passed as `@Ip_ApplicationId`.
   * @returns Returns the user's action entitlements for the given application.
   */
  actionEntitlementsAll4(userId: number, applicationId: number): Observable<UserActionEntitlementResultResponse[]>;
  /**
   * Adds one or more roles to multiple users in a single bulk operation. Skips role assignments that already exist,
   * making this operation safe to retry.
   *
   * @param body (optional) The bulk assignment request containing user IDs and role IDs.
   * @returns Returns the bulk assignment result with detailed metrics.
   */
  bulk(body?: BulkRoleAssignmentRequest | undefined): Observable<BulkRoleAssignmentResponse>;
  /**
   * Removes a direct user action entitlement by its primary key.
   *
   * @param id The unique identifier of the user action entitlement to remove.
   * @returns The user action entitlement was removed successfully.
   */
  actionEntitlementsDELETE3(id: number): Observable<void>;
  /**
   * Removes a user role assignment by its primary key.
   *
   * @param id The unique identifier of the user role assignment to remove.
   * @returns The user role assignment was removed successfully.
   */
  rolesDELETE2(id: number): Observable<void>;
  /**
   * Retrieves a paginated, filtered, and sorted list of users with their contact information, status, and role
   * assignments. Supports server-side paging, sorting, free-text search, and optional filtering by role name(s) and
   * user status. Implemented using Entity Framework LINQ queries for flexibility and performance.
   *
   * @param body (optional) Paged search request containing filter, sort, and pagination parameters.
   * @returns Returns the paged user list and total count.
   */
  search6(body?: UserListRequest | undefined): Observable<UserListItemResponsePagedResult>;
  /**
   * Gets users from the Central database with an optional active-only filter.
   *
   * @param activeOnly (optional) Optional filter. When `true`, returns only active users. When not provided, returns
   *   all users regardless of active status.
   * @returns Returns the list of users. All users are returned when activeOnly is not specified; only active users
   *   when set to `true`.
   */
  users(activeOnly?: boolean | undefined): Observable<UserSearchResponse[]>;
  /**
   * Searches users in the Central database with optional filtering, sorting, and pagination.
   *
   * @param body (optional) Search request with filter, sort, and pagination parameters.
   * @returns Returns the paged list of users matching the search criteria.
   */
  search7(body?: UserSearchRequest | undefined): Observable<UserSearchResponsePagedResult>;
  /**
   * Gets the current authenticated user's information including their user type. Uses the UserId from the JWT claims
   * to look up the user in the Central database.
   *
   * @returns Returns the current user's information.
   */
  userType(): Observable<UserSearchResponse>;
}

@Injectable()
export class Client implements IClient {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  private http = inject(HttpClient);
  private baseUrl = inject<string>(ADMIN_API_BASE_URL);

  /**
   * Retrieves every action entitlement group record.
   *
   * @returns Returns the list of action entitlement groups.
   */
  actionEntitlementGroupsAll(): Observable<ActionEntitlementGroupResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/action-entitlement-groups';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementGroupsAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementGroupsAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActionEntitlementGroupResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ActionEntitlementGroupResponse[]>;
        })
      );
  }

  protected processActionEntitlementGroupsAll(
    response: HttpResponseBase
  ): Observable<ActionEntitlementGroupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ActionEntitlementGroupResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates a new action entitlement group record.
   *
   * @param body (optional) The create request payload to persist.
   * @returns No Content
   */
  actionEntitlementGroupsPOST(body?: ActionEntitlementGroupCreateRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/action-entitlement-groups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementGroupsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementGroupsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActionEntitlementGroupsPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Model validation failed.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a single action entitlement group by its integer primary key.
   *
   * @param id The unique group identifier.
   * @returns Returns the requested group.
   */
  actionEntitlementGroupsGET(id: number): Observable<ActionEntitlementGroupResponse> {
    let url_ = this.baseUrl + '/api/UserManagement/action-entitlement-groups/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementGroupsGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementGroupsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActionEntitlementGroupResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ActionEntitlementGroupResponse>;
        })
      );
  }

  protected processActionEntitlementGroupsGET(response: HttpResponseBase): Observable<ActionEntitlementGroupResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ActionEntitlementGroupResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('No group with the given id exists.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves every action entitlement record from the database.
   *
   * @returns Returns the list of action entitlements.
   */
  actionEntitlementsAll(): Observable<ActionEntitlementResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/action-entitlements';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActionEntitlementResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ActionEntitlementResponse[]>;
        })
      );
  }

  protected processActionEntitlementsAll(response: HttpResponseBase): Observable<ActionEntitlementResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ActionEntitlementResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates a new action entitlement record.
   *
   * @param body (optional) The create request payload to persist.
   * @returns No Content
   */
  actionEntitlementsPOST(body?: ActionEntitlementCreateRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/action-entitlements';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActionEntitlementsPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Model validation failed.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a single action entitlement by its string code primary key.
   *
   * @param code The unique entitlement code (e.g. `"VIEW_USERS"`).
   * @returns Returns the requested action entitlement.
   */
  actionEntitlementsGET(code: string): Observable<ActionEntitlementResponse> {
    let url_ = this.baseUrl + '/api/UserManagement/action-entitlements/{code}';
    if (code === undefined || code === null) throw new globalThis.Error("The parameter 'code' must be defined.");
    url_ = url_.replace('{code}', encodeURIComponent('' + code));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActionEntitlementResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ActionEntitlementResponse>;
        })
      );
  }

  protected processActionEntitlementsGET(response: HttpResponseBase): Observable<ActionEntitlementResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ActionEntitlementResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException(
            'No entitlement with the given code exists.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Deletes an action entitlement by its string code.
   *
   * @param code The unique entitlement code to delete.
   * @returns The action entitlement was deleted.
   */
  actionEntitlementsDELETE(code: string): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/action-entitlements/{code}';
    if (code === undefined || code === null) throw new globalThis.Error("The parameter 'code' must be defined.");
    url_ = url_.replace('{code}', encodeURIComponent('' + code));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActionEntitlementsDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException(
            'No entitlement with the given code exists.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Searches activity logs with filtering, search, sorting, and pagination.
   *
   * @param body (optional) The search request containing filters, pagination, and search/sort parameters.
   * @returns Returns the paginated list of activity logs.
   */
  search(body?: ActivityLogFilterRequest | undefined): Observable<ActivityLogResponsePagedResult> {
    let url_ = this.baseUrl + '/api/ActivityLogs/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActivityLogResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<ActivityLogResponsePagedResult>;
        })
      );
  }

  protected processSearch(response: HttpResponseBase): Observable<ActivityLogResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ActivityLogResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Invalid filter parameters (e.g., page < 1, pageSize > 100, invalid sortColumn).',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all activity event types for use in filters and dropdowns.
   *
   * @param includeDeleted (optional) If true, includes deleted event types. Default is false.
   * @returns Returns the list of activity event types.
   */
  eventtypes(includeDeleted?: boolean | undefined): Observable<ActivityEventTypeResponse[]> {
    let url_ = this.baseUrl + '/api/ActivityLogs/eventtypes?';
    if (includeDeleted === null) throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
    else if (includeDeleted !== undefined) url_ += 'includeDeleted=' + encodeURIComponent('' + includeDeleted) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEventtypes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEventtypes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActivityEventTypeResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ActivityEventTypeResponse[]>;
        })
      );
  }

  protected processEventtypes(response: HttpResponseBase): Observable<ActivityEventTypeResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ActivityEventTypeResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all entity types for use in filters and dropdowns.
   *
   * @param includeDeleted (optional) If true, includes deleted entity types. Default is false.
   * @returns Returns the list of entity types.
   */
  entitytypes(includeDeleted?: boolean | undefined): Observable<EntityTypeResponse[]> {
    let url_ = this.baseUrl + '/api/ActivityLogs/entitytypes?';
    if (includeDeleted === null) throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
    else if (includeDeleted !== undefined) url_ += 'includeDeleted=' + encodeURIComponent('' + includeDeleted) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEntitytypes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEntitytypes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EntityTypeResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<EntityTypeResponse[]>;
        })
      );
  }

  protected processEntitytypes(response: HttpResponseBase): Observable<EntityTypeResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(EntityTypeResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all modules for use in filters and dropdowns.
   *
   * @param includeDeleted (optional) If true, includes deleted modules. Default is false.
   * @returns Returns the list of modules.
   */
  modules(includeDeleted?: boolean | undefined): Observable<ModuleResponse[]> {
    let url_ = this.baseUrl + '/api/ActivityLogs/modules?';
    if (includeDeleted === null) throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
    else if (includeDeleted !== undefined) url_ += 'includeDeleted=' + encodeURIComponent('' + includeDeleted) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processModules(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processModules(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ModuleResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ModuleResponse[]>;
        })
      );
  }

  protected processModules(response: HttpResponseBase): Observable<ModuleResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ModuleResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all step/event detail rows for a specific activity log entry, ordered by `SequenceNo`. Data is read
   * from `[ADMIN].[ActivityLogDetails]`.
   *
   * @param activityLogId The unique identifier of the parent activity log entry.
   * @returns Returns the ordered list of activity log detail rows.
   */
  details(activityLogId: number): Observable<ActivityLogDetailResponse[]> {
    let url_ = this.baseUrl + '/api/ActivityLogs/{activityLogId}/details';
    if (activityLogId === undefined || activityLogId === null)
      throw new globalThis.Error("The parameter 'activityLogId' must be defined.");
    url_ = url_.replace('{activityLogId}', encodeURIComponent('' + activityLogId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActivityLogDetailResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ActivityLogDetailResponse[]>;
        })
      );
  }

  protected processDetails(response: HttpResponseBase): Observable<ActivityLogDetailResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ActivityLogDetailResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException(
            'No activity log with the given activityLogId was found.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Logs an administrative activity from external services (e.g., login/logout events). Accepts string-based
   * codes/names and converts them to enum types internally.
   *
   * @param body (optional) The activity log request with string-based lookup values.
   * @returns Returns true if the activity was successfully logged, false otherwise.
   */
  activityLogs(body?: CreateActivityLogRequest | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ActivityLogs';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivityLogs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivityLogs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processActivityLogs(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Invalid request parameters, model validation failed, or invalid enum values.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Logs a batch of administrative activities in a single request. Intended for high-volume event sources that buffer
   * locally and flush in groups of 50.
   *
   * @param body (optional)
   * @returns OK
   */
  batch(body?: CreateActivityLogRequest[] | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/ActivityLogs/batch';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBatch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBatch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processBatch(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Exports all activity logs matching the filter as a downloadable CSV file. Rows are streamed directly from
   * `SqlDataReader` to the HTTP response body â€” server RAM usage is O(1) per request regardless of record count,
   * safe for 10 lakh+ records. A date range (`FromDate` and `ToDate`) is strongly recommended.
   *
   * @param body (optional) Filter criteria. Pagination fields are ignored.
   * @returns Streams a `text/csv` file containing the exported logs.
   */
  export(body?: ActivityLogFilterRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/ActivityLogs/export';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processExport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processExport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processExport(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Invalid request parameters.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all clients with their lines of business and intervention types.
   *
   * @param includeInactive (optional) Optional. Whether to include inactive clients. Default is false.
   * @returns Returns the list of clients.
   */
  clientsAll(includeInactive?: boolean | undefined): Observable<ClientManagementResponse[]> {
    let url_ = this.baseUrl + '/api/ClientManagement/clients?';
    if (includeInactive === null) throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
    else if (includeInactive !== undefined) url_ += 'includeInactive=' + encodeURIComponent('' + includeInactive) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClientsAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClientsAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ClientManagementResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ClientManagementResponse[]>;
        })
      );
  }

  protected processClientsAll(response: HttpResponseBase): Observable<ClientManagementResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ClientManagementResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Onboards a client from CODIS to the main Client table with associated configurations. Creates a Client record and
   * cross-joined ClientConfig records for all LOB and intervention type combinations.
   *
   * @param body (optional) The add client request containing client ID, LOB IDs, and intervention type IDs.
   * @returns No Content
   */
  clientsPOST(body?: AddClientRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/ClientManagement/clients';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClientsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClientsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processClientsPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Invalid request (missing LOBs/interventions, client not found in CODIS, or already onboarded).',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a paginated, filtered, and sorted list of clients. Supports server-side paging, sorting, free-text
   * search, and filtering.
   *
   * @param body (optional) Paged search request containing filter, sort, and pagination parameters.
   * @returns OK
   */
  search2(body?: ClientListRequest | undefined): Observable<ClientManagementResponsePagedResult> {
    let url_ = this.baseUrl + '/api/ClientManagement/clients/list/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ClientManagementResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<ClientManagementResponsePagedResult>;
        })
      );
  }

  protected processSearch2(response: HttpResponseBase): Observable<ClientManagementResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ClientManagementResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves detailed client information by client row ID including name, LOBs, and intervention types.
   *
   * @param clientId The client row identifier (surrogate key).
   * @returns Returns the requested client details.
   */
  clientsGET(clientId: number): Observable<ClientManagementData> {
    let url_ = this.baseUrl + '/api/ClientManagement/clients/{clientId}';
    if (clientId === undefined || clientId === null)
      throw new globalThis.Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClientsGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClientsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ClientManagementData>;
            }
          } else return _observableThrow(response_) as any as Observable<ClientManagementData>;
        })
      );
  }

  protected processClientsGET(response: HttpResponseBase): Observable<ClientManagementData> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ClientManagementData.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException(
            'No client with the given clientId was found.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves clients from CODIS that have not yet been onboarded to the main Client table. Used for populating
   * onboarding dropdowns with available clients.
   *
   * @returns Returns the list of unonboarded clients.
   */
  unonboardedClients(): Observable<UnonboardedClientResponse[]> {
    let url_ = this.baseUrl + '/api/ClientManagement/unonboarded-clients';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnonboardedClients(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnonboardedClients(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UnonboardedClientResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UnonboardedClientResponse[]>;
        })
      );
  }

  protected processUnonboardedClients(response: HttpResponseBase): Observable<UnonboardedClientResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UnonboardedClientResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Triggers the Azure DevOps onboarding pipeline for a client.
   *
   * @param clientId The client identifier.
   * @param body (optional) The pipeline trigger request.
   * @returns Pipeline trigger submitted.
   */
  pipeline(
    clientId: number,
    body?: TriggerClientOnboardingRequest | undefined
  ): Observable<TriggerClientOnboardingResponse> {
    let url_ = this.baseUrl + '/api/ClientManagement/clients/{clientId}/onboarding/pipeline';
    if (clientId === undefined || clientId === null)
      throw new globalThis.Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPipeline(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPipeline(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TriggerClientOnboardingResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<TriggerClientOnboardingResponse>;
        })
      );
  }

  protected processPipeline(response: HttpResponseBase): Observable<TriggerClientOnboardingResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TriggerClientOnboardingResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Invalid request.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates a client's LOB and intervention type configurations. Deletes all existing ClientConfig records and
   * creates new ones based on the cross join of provided LOBs and interventions.
   *
   * @param clientId The client row identifier.
   * @param body (optional) The update request containing LOB IDs and intervention type IDs.
   * @returns Configurations successfully updated.
   */
  configurations(
    clientId: number,
    body?: UpdateClientConfigurationRequest | undefined
  ): Observable<UpdateClientConfigurationResponse> {
    let url_ = this.baseUrl + '/api/ClientManagement/clients/{clientId}/configurations';
    if (clientId === undefined || clientId === null)
      throw new globalThis.Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processConfigurations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processConfigurations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateClientConfigurationResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateClientConfigurationResponse>;
        })
      );
  }

  protected processConfigurations(response: HttpResponseBase): Observable<UpdateClientConfigurationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UpdateClientConfigurationResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Invalid request (missing LOBs/interventions).',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Client not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Deactivates a client by setting its IsActive flag to false. The client will be excluded from all active client
   * queries and multi-tenancy resolution.
   *
   * @param clientId The business client identifier.
   * @returns Client successfully deactivated.
   */
  deactivate(clientId: number): Observable<DeactivateClientResponse> {
    let url_ = this.baseUrl + '/api/ClientManagement/clients/{clientId}/deactivate';
    if (clientId === undefined || clientId === null)
      throw new globalThis.Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeactivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeactivate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeactivateClientResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<DeactivateClientResponse>;
        })
      );
  }

  protected processDeactivate(response: HttpResponseBase): Observable<DeactivateClientResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DeactivateClientResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Client is already inactive.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Client not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all client-specific templates from the client template configuration table. Returns template name,
   * version, line of business, intervention type, effective dates, and assigned by information.
   *
   * @param clientId (optional) Optional. Filter templates by specific client ID.
   * @returns Returns the list of client-specific templates.
   */
  clientTemplates(clientId?: number | undefined): Observable<ClientSpecificTemplateResponse[]> {
    let url_ = this.baseUrl + '/api/ClientTemplates?';
    if (clientId === null) throw new globalThis.Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined) url_ += 'clientId=' + encodeURIComponent('' + clientId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClientTemplates(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClientTemplates(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ClientSpecificTemplateResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ClientSpecificTemplateResponse[]>;
        })
      );
  }

  protected processClientTemplates(response: HttpResponseBase): Observable<ClientSpecificTemplateResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ClientSpecificTemplateResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns OK */
  health(): Observable<void> {
    let url_ = this.baseUrl + '/health';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processHealth(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processHealth(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processHealth(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status === 503) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Service Unavailable', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns OK */
  detailed(): Observable<HealthCheckResponse> {
    let url_ = this.baseUrl + '/health/detailed';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDetailed(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDetailed(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<HealthCheckResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<HealthCheckResponse>;
        })
      );
  }

  protected processDetailed(response: HttpResponseBase): Observable<HealthCheckResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HealthCheckResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status === 503) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result503: any = null;
          let resultData503 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result503 = HealthCheckResponse.fromJS(resultData503);
          return throwException('Service Unavailable', status, _responseText, _headers, result503);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Starts an impersonation session by obtaining a JWT token for the specified user. Requires the `User.SimulateUser`
   * permission.
   *
   * @param body (optional) The impersonation start request containing the user email to impersonate.
   * @returns Returns the JWT token for successful impersonation.
   */
  token(body?: ImpersonationStartRequest | undefined): Observable<ImpersonationStartResponse> {
    let url_ = this.baseUrl + '/api/Impersonation/token';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processToken(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processToken(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ImpersonationStartResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ImpersonationStartResponse>;
        })
      );
  }

  protected processToken(response: HttpResponseBase): Observable<ImpersonationStartResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ImpersonationStartResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'If the request is invalid or validation fails.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException(
            'If the user lacks the required permission.',
            status,
            _responseText,
            _headers,
            result403
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('If an error occurs during token retrieval.', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Stops an impersonation session by invalidating the token for the specified user. Requires the `User.SimulateUser`
   * permission.
   *
   * @param body (optional) The impersonation stop request containing the user email and token ID.
   * @returns Returns success if the impersonation session was stopped.
   */
  logout(body?: ImpersonationStopRequest | undefined): Observable<ImpersonationStopResponse> {
    let url_ = this.baseUrl + '/api/Impersonation/logout';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLogout(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLogout(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ImpersonationStopResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ImpersonationStopResponse>;
        })
      );
  }

  protected processLogout(response: HttpResponseBase): Observable<ImpersonationStopResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ImpersonationStopResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'If the request is invalid or validation fails.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException(
            'If the user lacks the required permission.',
            status,
            _responseText,
            _headers,
            result403
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('If an error occurs during token invalidation.', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Sets the offline PIN for the authenticated nurse practitioner.
   *
   * @param body (optional) Request containing the PIN to set.
   * @returns PIN set successfully.
   */
  pinPOST(body?: SetNursePractitionerPinRequest | undefined): Observable<NursePractitionerPinResponse> {
    let url_ = this.baseUrl + '/api/Users/pin';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPinPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPinPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<NursePractitionerPinResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<NursePractitionerPinResponse>;
        })
      );
  }

  protected processPinPOST(response: HttpResponseBase): Observable<NursePractitionerPinResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NursePractitionerPinResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Invalid request or PIN format.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Nurse practitioner not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets the offline PIN for the authenticated nurse practitioner.
   *
   * @returns PIN retrieved successfully.
   */
  pinGET(): Observable<NursePractitionerPinResponse> {
    let url_ = this.baseUrl + '/api/Users/pin';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPinGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPinGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<NursePractitionerPinResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<NursePractitionerPinResponse>;
        })
      );
  }

  protected processPinGET(response: HttpResponseBase): Observable<NursePractitionerPinResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NursePractitionerPinResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Nurse practitioner not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets all active published release notes for a specific date. Returns all active releases without user-specific
   * filtering. Client applications filter dismissed releases using browser storage.
   *
   * @param date (optional) The date to check for active release notes. Defaults to current date.
   * @returns Returns the list of active release notes.
   */
  active(date?: string | undefined): Observable<ActiveReleaseNoteResponse[]> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement/active?';
    if (date === null) throw new globalThis.Error("The parameter 'date' cannot be null.");
    else if (date !== undefined) url_ += 'date=' + encodeURIComponent('' + date) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActive(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActive(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ActiveReleaseNoteResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ActiveReleaseNoteResponse[]>;
        })
      );
  }

  protected processActive(response: HttpResponseBase): Observable<ActiveReleaseNoteResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ActiveReleaseNoteResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets all published release notes for timeline view (past releases).
   *
   * @param fromDate (optional) Optional timestamp to filter release notes with StartDate <= fromDate. If not
   *   provided, defaults to the current UTC time.
   * @returns Returns the list of published releases.
   */
  published(fromDate?: string | undefined): Observable<ReleaseNoteTimelineResponse[]> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement/published?';
    if (fromDate === null) throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined) url_ += 'fromDate=' + encodeURIComponent('' + fromDate) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPublished(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPublished(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseNoteTimelineResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseNoteTimelineResponse[]>;
        })
      );
  }

  protected processPublished(response: HttpResponseBase): Observable<ReleaseNoteTimelineResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ReleaseNoteTimelineResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets all published release notes with full details (including items).
   *
   * @param fromDate (optional) Optional date to filter release notes with StartDate <= fromDate. If not provided,
   *   defaults to today.
   * @returns Returns the list of published releases with full details.
   */
  viewAll(fromDate?: string | undefined): Observable<ReleaseNoteViewResponse[]> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement/view?';
    if (fromDate === null) throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined) url_ += 'fromDate=' + encodeURIComponent('' + fromDate) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processViewAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processViewAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseNoteViewResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseNoteViewResponse[]>;
        })
      );
  }

  protected processViewAll(response: HttpResponseBase): Observable<ReleaseNoteViewResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ReleaseNoteViewResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets full release note details for viewing (used in "View summary" link).
   *
   * @param id The unique identifier of the release note.
   * @param fromDate (optional) Optional date to filter release notes with StartDate <= fromDate. If not provided,
   *   defaults to today.
   * @returns Returns the release note for viewing.
   */
  view(id: number, fromDate?: string | undefined): Observable<ReleaseNoteViewResponse> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement/{id}/view?';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (fromDate === null) throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined) url_ += 'fromDate=' + encodeURIComponent('' + fromDate) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processView(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processView(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseNoteViewResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseNoteViewResponse>;
        })
      );
  }

  protected processView(response: HttpResponseBase): Observable<ReleaseNoteViewResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReleaseNoteViewResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Release note not found or not published.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all release notes with pagination (admin history grid).
   *
   * @param offset (optional) Number of records to skip. Default is 0.
   * @param limit (optional) Maximum number of records to return. Must be between 1 and 100. Default is 50.
   * @returns Returns the paginated list of release notes.
   */
  releaseNotesManagementGET(
    offset?: number | undefined,
    limit?: number | undefined
  ): Observable<ReleaseNoteResponsePagedResult> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement?';
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += 'offset=' + encodeURIComponent('' + offset) + '&';
    if (limit === null) throw new globalThis.Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += 'limit=' + encodeURIComponent('' + limit) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReleaseNotesManagementGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReleaseNotesManagementGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseNoteResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseNoteResponsePagedResult>;
        })
      );
  }

  protected processReleaseNotesManagementGET(response: HttpResponseBase): Observable<ReleaseNoteResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReleaseNoteResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Invalid pagination parameters.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates a new release note as Draft or Published.
   *
   * @param body (optional) The release note creation request.
   * @returns No Content
   */
  releaseNotesManagementPOST(body?: CreateReleaseNoteRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReleaseNotesManagementPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReleaseNotesManagementPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processReleaseNotesManagementPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Invalid request data or validation failed.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Searches release notes with pagination, filtering, and sorting (admin management grid).
   *
   * @param body (optional) Search request with pagination, free-text search, column selection, and sorting.
   * @returns Returns the paginated list of release notes.
   */
  releaseNotesSearch(body?: ReleaseNoteSearchRequest | undefined): Observable<ReleaseNoteResponsePagedResult> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement/release-notes-search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReleaseNotesSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReleaseNotesSearch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseNoteResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseNoteResponsePagedResult>;
        })
      );
  }

  protected processReleaseNotesSearch(response: HttpResponseBase): Observable<ReleaseNoteResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReleaseNoteResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a release note by ID with full details and change history.
   *
   * @param id The unique identifier of the release note.
   * @returns Returns the release note details.
   */
  releaseNotesManagementGET2(id: number): Observable<ReleaseNoteResponse> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReleaseNotesManagementGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReleaseNotesManagementGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseNoteResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseNoteResponse>;
        })
      );
  }

  protected processReleaseNotesManagementGET2(response: HttpResponseBase): Observable<ReleaseNoteResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReleaseNoteResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Release note not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates an existing release note.
   *
   * @param id The unique identifier of the release note to update.
   * @param body (optional) The updated release note data.
   * @returns Release note updated successfully.
   */
  releaseNotesManagementPUT(id: number, body?: UpdateReleaseNoteRequest | undefined): Observable<ReleaseNoteResponse> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReleaseNotesManagementPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReleaseNotesManagementPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseNoteResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseNoteResponse>;
        })
      );
  }

  protected processReleaseNotesManagementPUT(response: HttpResponseBase): Observable<ReleaseNoteResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReleaseNoteResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Invalid request data or validation failed.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Release note not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException(
            'Cannot edit expired or published release note.',
            status,
            _responseText,
            _headers,
            result409
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Soft deletes a release note (sets IsDeleted flag).
   *
   * @param id The unique identifier of the release note to delete.
   * @returns Release note deleted successfully.
   */
  releaseNotesManagementDELETE(id: number): Observable<any> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReleaseNotesManagementDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReleaseNotesManagementDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<any>;
            }
          } else return _observableThrow(response_) as any as Observable<any>;
        })
      );
  }

  protected processReleaseNotesManagementDELETE(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Release note not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException(
            'Cannot delete published or active release note, or already deleted.',
            status,
            _responseText,
            _headers,
            result409
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Publishes a draft release note, making it active during the configured date range.
   *
   * @param id The unique identifier of the release note to publish.
   * @returns Release note published successfully.
   */
  publish(id: number): Observable<ReleaseNoteResponse> {
    let url_ = this.baseUrl + '/api/ReleaseNotesManagement/{id}/publish';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPublish(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPublish(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseNoteResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseNoteResponse>;
        })
      );
  }

  protected processPublish(response: HttpResponseBase): Observable<ReleaseNoteResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReleaseNoteResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Release note cannot be published (validation failed).',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Release note not found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Release note is not in Draft status.', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all role-action entitlement mappings for the specified role.
   *
   * @param roleId The role identifier to filter by.
   * @returns Returns the list of role-entitlement assignments.
   */
  actionEntitlementsAll2(roleId: number): Observable<RoleActionEntitlementResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/roles/{roleId}/action-entitlements';
    if (roleId === undefined || roleId === null) throw new globalThis.Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsAll2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsAll2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleActionEntitlementResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleActionEntitlementResponse[]>;
        })
      );
  }

  protected processActionEntitlementsAll2(response: HttpResponseBase): Observable<RoleActionEntitlementResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(RoleActionEntitlementResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Synchronizes a role's action entitlements. Removes action entitlements not in the payload and adds new ones.
   * Existing assignments that match are kept intact.
   *
   * @param roleId The role identifier from the route.
   * @param body (optional) The sync request containing the desired permission codes.
   * @returns The role's action entitlements were synchronized successfully.
   */
  actionEntitlementsPUT(roleId: number, body?: SyncRoleActionEntitlementsRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/roles/{roleId}/action-entitlements';
    if (roleId === undefined || roleId === null) throw new globalThis.Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActionEntitlementsPUT(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Model validation failed.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Assigns an action entitlement to a role by creating a mapping row.
   *
   * @param body (optional) The request payload containing the role and entitlement identifiers.
   * @returns No Content
   */
  actionEntitlementsPOST2(body?: RoleActionEntitlementCreateRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/roles/action-entitlements';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActionEntitlementsPOST2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Removes a role-action entitlement assignment by its mapping row identifier.
   *
   * @param id The primary key of the role-action entitlement mapping to remove.
   * @returns The assignment was removed.
   */
  actionEntitlementsDELETE2(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/roles/action-entitlements/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActionEntitlementsDELETE2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('No mapping with the given id exists.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves every role as a Response with user counts.
   *
   * @returns Returns the list of roles.
   */
  rolesAllGET(): Observable<RoleResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/roles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesAllGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesAllGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleResponse[]>;
        })
      );
  }

  protected processRolesAllGET(response: HttpResponseBase): Observable<RoleResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(RoleResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates a new role record.
   *
   * @param body (optional) The create request payload. Model binding reads the JSON request body.
   * @returns No Content
   */
  rolesPOST(body?: RoleCreateRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRolesPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'The request body failed model validation.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a single role as a Response by its integer primary key.
   *
   * @param id The unique identifier of the role.
   * @returns Returns the requested role.
   */
  rolesGET(id: number): Observable<RoleResponse> {
    let url_ = this.baseUrl + '/api/UserManagement/roles/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleResponse>;
        })
      );
  }

  protected processRolesGET(response: HttpResponseBase): Observable<RoleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RoleResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('No role with the given id was found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates an existing role. The route id must match Admin.Models.Request.RoleUpdateRequest.Id in the request body;
   * otherwise a `400 Bad Request` is returned.
   *
   * @param id The role identifier from the route.
   * @param body (optional) The updated role payload from the JSON request body.
   * @returns The role was updated successfully.
   */
  rolesPUT(id: number, body?: RoleUpdateRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/roles/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRolesPUT(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Route id does not match entity id, or model validation failed.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Deletes a role by its integer primary key.
   *
   * @param id The unique identifier of the role to delete.
   * @returns The role was deleted successfully.
   */
  rolesDELETE(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/roles/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRolesDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('No role with the given id was found.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Synchronizes a role's user assignments. Removes users not in the payload and adds new ones. Existing assignments
   * that match are kept intact.
   *
   * @param roleId The role identifier from the route.
   * @param body (optional) The sync request containing the desired user IDs.
   * @returns The role's user assignments were synchronized successfully.
   */
  usersPUT(roleId: number, body?: SyncRoleUsersRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/roles/{roleId}/users';
    if (roleId === undefined || roleId === null) throw new globalThis.Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUsersPUT(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Model validation failed.', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all permissions organized in a hierarchical structure by groups. Parent groups contain child groups;
   * leaf groups contain permissions with assignment status. Use this endpoint for UI to display a tree view of
   * permissions.
   *
   * @param roleId The role identifier from the route.
   * @returns Returns the hierarchical permissions matrix.
   */
  permissionsMatrixHierarchical(roleId: number): Observable<PermissionGroupNodeResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/roles/{roleId}/permissions-matrix-hierarchical';
    if (roleId === undefined || roleId === null) throw new globalThis.Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermissionsMatrixHierarchical(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermissionsMatrixHierarchical(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PermissionGroupNodeResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<PermissionGroupNodeResponse[]>;
        })
      );
  }

  protected processPermissionsMatrixHierarchical(
    response: HttpResponseBase
  ): Observable<PermissionGroupNodeResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PermissionGroupNodeResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Searches rule groups with pagination, filtering, and sorting.
   *
   * @param body (optional) Paged search request.
   * @returns OK
   */
  search3(body?: RuleGroupSearchRequest | undefined): Observable<RuleGroupResponsePagedResult> {
    let url_ = this.baseUrl + '/api/RuleGroups/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch3(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RuleGroupResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<RuleGroupResponsePagedResult>;
        })
      );
  }

  protected processSearch3(response: HttpResponseBase): Observable<RuleGroupResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RuleGroupResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets rule groups that contain at least one rule matching the given categories, without pagination.
   *
   * @param categoryIds (optional) Comma-separated category identifiers used to filter matching rule groups.
   * @param isActive (optional) Optional active status filter.
   * @returns OK
   */
  ruleGroupsByCategory(
    categoryIds?: string | undefined,
    isActive?: boolean | undefined
  ): Observable<RuleGroupResponse[]> {
    let url_ = this.baseUrl + '/api/RuleGroups/rule-groups-by-category?';
    if (categoryIds === null) throw new globalThis.Error("The parameter 'categoryIds' cannot be null.");
    else if (categoryIds !== undefined) url_ += 'categoryIds=' + encodeURIComponent('' + categoryIds) + '&';
    if (isActive === null) throw new globalThis.Error("The parameter 'isActive' cannot be null.");
    else if (isActive !== undefined) url_ += 'isActive=' + encodeURIComponent('' + isActive) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRuleGroupsByCategory(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRuleGroupsByCategory(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RuleGroupResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<RuleGroupResponse[]>;
        })
      );
  }

  protected processRuleGroupsByCategory(response: HttpResponseBase): Observable<RuleGroupResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(RuleGroupResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets a rule group by identifier including its rules.
   *
   * @param id Rule group identifier.
   * @returns OK
   */
  ruleGroupsGET(id: number): Observable<RuleGroupDetailResponse> {
    let url_ = this.baseUrl + '/api/RuleGroups/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRuleGroupsGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRuleGroupsGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RuleGroupDetailResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RuleGroupDetailResponse>;
        })
      );
  }

  protected processRuleGroupsGET(response: HttpResponseBase): Observable<RuleGroupDetailResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RuleGroupDetailResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates an existing rule group.
   *
   * @param id Rule group identifier.
   * @param body (optional) Update request payload.
   * @returns No Content
   */
  ruleGroupsPUT(id: number, body?: UpdateRuleGroupRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/RuleGroups/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRuleGroupsPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRuleGroupsPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRuleGroupsPUT(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Deletes a rule group.
   *
   * @param id Rule group identifier.
   * @returns No Content
   */
  ruleGroupsDELETE(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/RuleGroups/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRuleGroupsDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRuleGroupsDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRuleGroupsDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates a new rule group.
   *
   * @param body (optional) Create request payload.
   * @returns No Content
   */
  ruleGroupsPOST(body?: CreateRuleGroupRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/RuleGroups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRuleGroupsPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRuleGroupsPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRuleGroupsPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Activates or deactivates an existing rule group.
   *
   * @param id Rule group identifier.
   * @param body (optional) Status update request payload.
   * @returns No Content
   */
  activateDeactivate(id: number, body?: ActivateDeactivateRuleGroupRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/RuleGroups/{id}/activate-deactivate';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivateDeactivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivateDeactivate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActivateDeactivate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Searches rules with pagination, filtering, and sorting.
   *
   * @param body (optional) Paged search request.
   * @returns OK
   */
  search4(body?: RuleQueryRequest | undefined): Observable<RuleDetailResponsePagedResult> {
    let url_ = this.baseUrl + '/api/Rules/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch4(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch4(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RuleDetailResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<RuleDetailResponsePagedResult>;
        })
      );
  }

  protected processSearch4(response: HttpResponseBase): Observable<RuleDetailResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RuleDetailResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets all rules for the specified rule group.
   *
   * @param ruleGroupId (optional) Parent rule-group identifier.
   * @param categoryIds (optional) Optional category identifiers used to filter the returned rules.
   * @returns OK
   */
  rulesAll(ruleGroupId?: number | undefined, categoryIds?: string | undefined): Observable<RuleDetailResponse[]> {
    let url_ = this.baseUrl + '/api/Rules?';
    if (ruleGroupId === null) throw new globalThis.Error("The parameter 'ruleGroupId' cannot be null.");
    else if (ruleGroupId !== undefined) url_ += 'ruleGroupId=' + encodeURIComponent('' + ruleGroupId) + '&';
    if (categoryIds === null) throw new globalThis.Error("The parameter 'categoryIds' cannot be null.");
    else if (categoryIds !== undefined) url_ += 'categoryIds=' + encodeURIComponent('' + categoryIds) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRulesAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRulesAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RuleDetailResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<RuleDetailResponse[]>;
        })
      );
  }

  protected processRulesAll(response: HttpResponseBase): Observable<RuleDetailResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(RuleDetailResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates a new rule.
   *
   * @param body (optional) Create request payload.
   * @returns No Content
   */
  rulesPOST(body?: CreateRuleRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Rules';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRulesPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRulesPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRulesPOST(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets details for a single rule.
   *
   * @param id Rule identifier.
   * @returns OK
   */
  rulesGET(id: number): Observable<RuleDetailResponse> {
    let url_ = this.baseUrl + '/api/Rules/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRulesGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRulesGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RuleDetailResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<RuleDetailResponse>;
        })
      );
  }

  protected processRulesGET(response: HttpResponseBase): Observable<RuleDetailResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RuleDetailResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Deletes a rule.
   *
   * @param id Rule identifier.
   * @returns No Content
   */
  rulesDELETE(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/Rules/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRulesDELETE(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRulesDELETE(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRulesDELETE(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Activates or deactivates an existing rule.
   *
   * @param id Rule identifier.
   * @param body (optional) Status update request payload.
   * @returns No Content
   */
  activateDeactivate2(id: number, body?: ActivateDeactivateRuleRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Rules/{id}/activate-deactivate';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivateDeactivate2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivateDeactivate2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActivateDeactivate2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a denormalized list of all user details including their associated metadata.
   *
   * @returns Returns the user details data.
   */
  userDetails(): Observable<UserDetailResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/user-details';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserDetailResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserDetailResponse[]>;
        })
      );
  }

  protected processUserDetails(response: HttpResponseBase): Observable<UserDetailResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserDetailResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves user details for a specific user.
   *
   * @param userId The user identifier to filter by.
   * @returns Returns the user detail data for the specified user.
   */
  userDetails2(userId: number): Observable<UserDetailByIdResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/user-details/{userId}';
    if (userId === undefined || userId === null) throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserDetails2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserDetails2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserDetailByIdResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserDetailByIdResponse[]>;
        })
      );
  }

  protected processUserDetails2(response: HttpResponseBase): Observable<UserDetailByIdResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserDetailByIdResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves user roles details for a specific user including application and entitlement information.
   *
   * @param userId The user identifier to filter by.
   * @returns Returns the user roles detail data for the specified user.
   */
  userRoles(userId: number): Observable<UserRolesDetailByIdResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/user-roles/{userId}';
    if (userId === undefined || userId === null) throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserRoles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserRolesDetailByIdResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserRolesDetailByIdResponse[]>;
        })
      );
  }

  protected processUserRoles(response: HttpResponseBase): Observable<UserRolesDetailByIdResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserRolesDetailByIdResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all users belonging to the configured application.
   *
   * @returns Returns the list of users.
   */
  usersAll(): Observable<UmUserResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/users';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UmUserResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UmUserResponse[]>;
        })
      );
  }

  protected processUsersAll(response: HttpResponseBase): Observable<UmUserResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UmUserResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates a new User.Domain.Entities.UserManagement.UmUser record and synchronizes to Central database. If
   * UserTypeId = 1, also creates a practitioner record.
   *
   * @param body (optional) The user data to persist. Model binding reads the JSON request body.
   * @returns The user was created successfully.
   */
  usersPOST(body?: UserCreateRequest | undefined): Observable<UserCreateResponse> {
    let url_ = this.baseUrl + '/api/UserManagement/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersPOST(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersPOST(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserCreateResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UserCreateResponse>;
        })
      );
  }

  protected processUsersPOST(response: HttpResponseBase): Observable<UserCreateResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserCreateResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'The request body failed model validation.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves users filtered by one or more user type IDs.
   *
   * @param body (optional) Comma-separated list of user type IDs to filter by (e.g., "1,2,3").
   * @returns Returns the filtered list of users.
   */
  userTypesIds(body?: number[] | undefined): Observable<UserResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/users/user-types-ids';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserTypesIds(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserTypesIds(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserResponse[]>;
        })
      );
  }

  protected processUserTypesIds(response: HttpResponseBase): Observable<UserResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'UserTypeIds parameter is required or invalid.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves users of a specific vendor and filtered by one or more user type IDs
   *
   * @param body (optional) The vendor and user type identifiers to filter by.
   * @returns Returns the filtered list of users.
   */
  userTypesIds2(body?: VendorUsersByTypeRequest | undefined): Observable<UserResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/users/vendor/user-types-ids';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserTypesIds2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserTypesIds2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserResponse[]>;
        })
      );
  }

  protected processUserTypesIds2(response: HttpResponseBase): Observable<UserResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all active users for the logged-in user's vendor(s) from the Central database. Automatically scoped to
   * the current user's vendors via IApplicationContext.VendorIds from JWT. Returns results in UserSearchResponse
   * format (UserId, UserName, EmailAddress, UserTypeId). Useful for dropdown filters and user selection lists.
   *
   * @returns Returns the list of active users for the logged-in user's vendor(s).
   */
  vendorUsers(): Observable<UserSearchResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/vendor-users';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVendorUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVendorUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserSearchResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserSearchResponse[]>;
        })
      );
  }

  protected processVendorUsers(response: HttpResponseBase): Observable<UserSearchResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserSearchResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a single user by its integer primary key, if they belong to the configured application.
   *
   * @param id The unique identifier of the user.
   * @returns Returns the requested user.
   */
  usersGET(id: number): Observable<UserResponse> {
    let url_ = this.baseUrl + '/api/UserManagement/users/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersGET(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersGET(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UserResponse>;
        })
      );
  }

  protected processUsersGET(response: HttpResponseBase): Observable<UserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException(
            'No user with the given id was found in the application.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates an existing user. The route id must match Admin.Models.Request.UserUpdateRequest.Id in the request body;
   * otherwise a `400 Bad Request` is returned.
   *
   * @param id The user identifier from the route.
   * @param body (optional) The updated user payload from the JSON request body.
   * @returns The user was updated successfully.
   */
  usersPUT2(id: number, body?: UserUpdateRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/users/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersPUT2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersPUT2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUsersPUT2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Route id does not match entity id, or model validation failed.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves salt key for the specified user.
   *
   * @param id The unique identifier of the user.
   * @returns Returns the requested salt key.
   */
  saltKey(id: number): Observable<string> {
    let url_ = this.baseUrl + '/api/UserManagement/users/{id}/salt-key';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaltKey(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaltKey(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processSaltKey(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException(
            'No user with the given id or the user is inactive.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Checks whether a user with the specified email address already exists.
   *
   * @param email The email address to check.
   * @returns Returns true if the email exists, false otherwise.
   */
  emailExists(email: string): Observable<boolean> {
    let url_ = this.baseUrl + '/api/UserManagement/users/email-exists?';
    if (email === undefined || email === null)
      throw new globalThis.Error("The parameter 'email' must be defined and cannot be null.");
    else url_ += 'email=' + encodeURIComponent('' + email) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailExists(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailExists(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processEmailExists(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Email address parameter was not provided or is empty.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Activates user by userId.
   *
   * @param id The user identifier from the route.
   * @returns No Content
   */
  activate(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/users/{id}/activate';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActivate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Bulk deactivates multiple users in an optimized batch operation. Orchestrates user deactivation across
   * UserManagement, Central, and Practitioner services. Implements continue-on-error strategy with detailed failure
   * tracking. Maximum 500 users per request.
   *
   * @param body (optional) The bulk deactivate request containing user IDs (max 500).
   * @returns Bulk deactivation completed (with or without individual failures).
   */
  bulkDeactivate(body?: BulkDeactivateUsersRequest | undefined): Observable<BulkDeactivateUsersResponse> {
    let url_ = this.baseUrl + '/api/UserManagement/users/bulk-deactivate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulkDeactivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulkDeactivate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BulkDeactivateUsersResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<BulkDeactivateUsersResponse>;
        })
      );
  }

  protected processBulkDeactivate(response: HttpResponseBase): Observable<BulkDeactivateUsersResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BulkDeactivateUsersResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Request validation failed (empty list, exceeds max size, or other validation errors).',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all user-action entitlement mappings for the specified user.
   *
   * @param userId The user identifier to filter by.
   * @returns Returns the list of user-entitlement assignments.
   */
  actionEntitlementsAll3(userId: number): Observable<UserActionEntitlementResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/users/{userId}/action-entitlements';
    if (userId === undefined || userId === null) throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsAll3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsAll3(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserActionEntitlementResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserActionEntitlementResponse[]>;
        })
      );
  }

  protected processActionEntitlementsAll3(response: HttpResponseBase): Observable<UserActionEntitlementResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserActionEntitlementResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Assigns an action entitlement directly to a user by creating a mapping row.
   *
   * @param body (optional) The request payload containing the user and entitlement identifiers.
   * @returns No Content
   */
  actionEntitlementsPOST3(body?: UserActionEntitlementCreateRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/users/action-entitlements';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsPOST3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsPOST3(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActionEntitlementsPOST3(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all user-role mappings for the specified user.
   *
   * @param userId The user identifier to filter by.
   * @returns Returns the list of role assignments for the user.
   */
  rolesAllGET2(userId: number): Observable<UserRoleResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/users/{userId}/roles';
    if (userId === undefined || userId === null) throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesAllGET2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesAllGET2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserRoleResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserRoleResponse[]>;
        })
      );
  }

  protected processRolesAllGET2(response: HttpResponseBase): Observable<UserRoleResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserRoleResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Synchronizes (replaces) all role assignments for a user. Removes roles not in the provided list and adds new
   * ones. This is an idempotent operation.
   *
   * @param userId The user identifier from the route.
   * @param body (optional) The complete list of role IDs to assign to the user.
   * @returns Returns the updated list of user roles.
   */
  rolesAllPUT(userId: number, body?: number[] | undefined): Observable<UserRoleResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/users/{userId}/roles';
    if (userId === undefined || userId === null) throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesAllPUT(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesAllPUT(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserRoleResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserRoleResponse[]>;
        })
      );
  }

  protected processRolesAllPUT(response: HttpResponseBase): Observable<UserRoleResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserRoleResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Model validation failed or userId is invalid.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Assigns a role to a user by creating a mapping row.
   *
   * @param body (optional) The request payload containing the user and role identifiers.
   * @returns No Content
   */
  rolesPOST2(body?: UserRoleCreateRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/users/roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesPOST2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesPOST2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRolesPOST2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          // 201 Created is a success status - return success, not exception
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Executes the `[dbo].[usp_Get_Users]` stored procedure with server-side paging, search, sort, and optional
   * client/application filters. Returns both the result set and the total matching row count for pagination
   * metadata.
   *
   * @param body (optional) The paged/filtered request body containing page, page size, search, sort, client and
   *   application filters.
   * @returns Returns the paged user list with pagination metadata.
   */
  search5(body?: GetUsersRequest | undefined): Observable<GetUsersResultResponsePagedResult> {
    let url_ = this.baseUrl + '/api/UserManagement/users/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch5(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch5(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUsersResultResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUsersResultResponsePagedResult>;
        })
      );
  }

  protected processSearch5(response: HttpResponseBase): Observable<GetUsersResultResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetUsersResultResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Executes the `[dbo].[usp_Get_User_Action_Entitlements]` stored procedure for a given user and application
   * combination.
   *
   * @param userId The user identifier passed as `@Ip_UserId`.
   * @param applicationId The application identifier passed as `@Ip_ApplicationId`.
   * @returns Returns the user's action entitlements for the given application.
   */
  actionEntitlementsAll4(userId: number, applicationId: number): Observable<UserActionEntitlementResultResponse[]> {
    let url_ = this.baseUrl + '/api/UserManagement/users/{userId}/action-entitlements/{applicationId}';
    if (userId === undefined || userId === null) throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (applicationId === undefined || applicationId === null)
      throw new globalThis.Error("The parameter 'applicationId' must be defined.");
    url_ = url_.replace('{applicationId}', encodeURIComponent('' + applicationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsAll4(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsAll4(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserActionEntitlementResultResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserActionEntitlementResultResponse[]>;
        })
      );
  }

  protected processActionEntitlementsAll4(
    response: HttpResponseBase
  ): Observable<UserActionEntitlementResultResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserActionEntitlementResultResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Adds one or more roles to multiple users in a single bulk operation. Skips role assignments that already exist,
   * making this operation safe to retry.
   *
   * @param body (optional) The bulk assignment request containing user IDs and role IDs.
   * @returns Returns the bulk assignment result with detailed metrics.
   */
  bulk(body?: BulkRoleAssignmentRequest | undefined): Observable<BulkRoleAssignmentResponse> {
    let url_ = this.baseUrl + '/api/UserManagement/users/roles/bulk';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulk(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulk(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BulkRoleAssignmentResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<BulkRoleAssignmentResponse>;
        })
      );
  }

  protected processBulk(response: HttpResponseBase): Observable<BulkRoleAssignmentResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BulkRoleAssignmentResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'Request validation failed (empty user or role list).',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Removes a direct user action entitlement by its primary key.
   *
   * @param id The unique identifier of the user action entitlement to remove.
   * @returns The user action entitlement was removed successfully.
   */
  actionEntitlementsDELETE3(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/users/action-entitlements/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActionEntitlementsDELETE3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActionEntitlementsDELETE3(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processActionEntitlementsDELETE3(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException(
            'No user action entitlement with the given id was found.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Removes a user role assignment by its primary key.
   *
   * @param id The unique identifier of the user role assignment to remove.
   * @returns The user role assignment was removed successfully.
   */
  rolesDELETE2(id: number): Observable<void> {
    let url_ = this.baseUrl + '/api/UserManagement/users/roles/{id}';
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesDELETE2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesDELETE2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRolesDELETE2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException(
            'No user role assignment with the given id was found.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a paginated, filtered, and sorted list of users with their contact information, status, and role
   * assignments. Supports server-side paging, sorting, free-text search, and optional filtering by role name(s) and
   * user status. Implemented using Entity Framework LINQ queries for flexibility and performance.
   *
   * @param body (optional) Paged search request containing filter, sort, and pagination parameters.
   * @returns Returns the paged user list and total count.
   */
  search6(body?: UserListRequest | undefined): Observable<UserListItemResponsePagedResult> {
    let url_ = this.baseUrl + '/api/UserManagement/users/list/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch6(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch6(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserListItemResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<UserListItemResponsePagedResult>;
        })
      );
  }

  protected processSearch6(response: HttpResponseBase): Observable<UserListItemResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserListItemResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets users from the Central database with an optional active-only filter.
   *
   * @param activeOnly (optional) Optional filter. When `true`, returns only active users. When not provided, returns
   *   all users regardless of active status.
   * @returns Returns the list of users. All users are returned when activeOnly is not specified; only active users
   *   when set to `true`.
   */
  users(activeOnly?: boolean | undefined): Observable<UserSearchResponse[]> {
    let url_ = this.baseUrl + '/api/Users?';
    if (activeOnly === null) throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
    else if (activeOnly !== undefined) url_ += 'activeOnly=' + encodeURIComponent('' + activeOnly) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserSearchResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserSearchResponse[]>;
        })
      );
  }

  protected processUsers(response: HttpResponseBase): Observable<UserSearchResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserSearchResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Searches users in the Central database with optional filtering, sorting, and pagination.
   *
   * @param body (optional) Search request with filter, sort, and pagination parameters.
   * @returns Returns the paged list of users matching the search criteria.
   */
  search7(body?: UserSearchRequest | undefined): Observable<UserSearchResponsePagedResult> {
    let url_ = this.baseUrl + '/api/Users/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch7(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch7(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserSearchResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<UserSearchResponsePagedResult>;
        })
      );
  }

  protected processSearch7(response: HttpResponseBase): Observable<UserSearchResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserSearchResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets the current authenticated user's information including their user type. Uses the UserId from the JWT claims
   * to look up the user in the Central database.
   *
   * @returns Returns the current user's information.
   */
  userType(): Observable<UserSearchResponse> {
    let url_ = this.baseUrl + '/api/Users/user-type';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserType(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserSearchResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<UserSearchResponse>;
        })
      );
  }

  protected processUserType(response: HttpResponseBase): Observable<UserSearchResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserSearchResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('A valid userId claim is required.', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('User not found in the Central database.', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }
}

export class ActionEntitlementCreateRequest implements IActionEntitlementCreateRequest {
  actionEntitlementGroupId?: number | undefined;
  code!: string;
  description?: string | undefined;
  isActive?: number | undefined;
  isClientEntitlement?: boolean;

  constructor(data?: IActionEntitlementCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.actionEntitlementGroupId = _data['actionEntitlementGroupId'];
      this.code = _data['code'];
      this.description = _data['description'];
      this.isActive = _data['isActive'];
      this.isClientEntitlement = _data['isClientEntitlement'];
    }
  }

  static fromJS(data: any): ActionEntitlementCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ActionEntitlementCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['actionEntitlementGroupId'] = this.actionEntitlementGroupId;
    data['code'] = this.code;
    data['description'] = this.description;
    data['isActive'] = this.isActive;
    data['isClientEntitlement'] = this.isClientEntitlement;
    return data;
  }
}

export interface IActionEntitlementCreateRequest {
  actionEntitlementGroupId?: number | undefined;
  code: string;
  description?: string | undefined;
  isActive?: number | undefined;
  isClientEntitlement?: boolean;
}

export class ActionEntitlementGroupCreateRequest implements IActionEntitlementGroupCreateRequest {
  shortName!: string;
  parentGroupId?: number | undefined;
  displayName?: string | undefined;
  applicationId?: number | undefined;
  isActive?: boolean | undefined;
  isAccessible?: boolean;

  constructor(data?: IActionEntitlementGroupCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.shortName = _data['shortName'];
      this.parentGroupId = _data['parentGroupId'];
      this.displayName = _data['displayName'];
      this.applicationId = _data['applicationId'];
      this.isActive = _data['isActive'];
      this.isAccessible = _data['isAccessible'];
    }
  }

  static fromJS(data: any): ActionEntitlementGroupCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ActionEntitlementGroupCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['shortName'] = this.shortName;
    data['parentGroupId'] = this.parentGroupId;
    data['displayName'] = this.displayName;
    data['applicationId'] = this.applicationId;
    data['isActive'] = this.isActive;
    data['isAccessible'] = this.isAccessible;
    return data;
  }
}

export interface IActionEntitlementGroupCreateRequest {
  shortName: string;
  parentGroupId?: number | undefined;
  displayName?: string | undefined;
  applicationId?: number | undefined;
  isActive?: boolean | undefined;
  isAccessible?: boolean;
}

export class ActionEntitlementGroupResponse implements IActionEntitlementGroupResponse {
  id?: number;
  shortName?: string | undefined;
  parentGroupId?: number | undefined;
  displayName?: string | undefined;
  applicationId?: number | undefined;
  isActive?: boolean | undefined;
  isAccessible?: boolean;

  constructor(data?: IActionEntitlementGroupResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.shortName = _data['shortName'];
      this.parentGroupId = _data['parentGroupId'];
      this.displayName = _data['displayName'];
      this.applicationId = _data['applicationId'];
      this.isActive = _data['isActive'];
      this.isAccessible = _data['isAccessible'];
    }
  }

  static fromJS(data: any): ActionEntitlementGroupResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ActionEntitlementGroupResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['shortName'] = this.shortName;
    data['parentGroupId'] = this.parentGroupId;
    data['displayName'] = this.displayName;
    data['applicationId'] = this.applicationId;
    data['isActive'] = this.isActive;
    data['isAccessible'] = this.isAccessible;
    return data;
  }
}

export interface IActionEntitlementGroupResponse {
  id?: number;
  shortName?: string | undefined;
  parentGroupId?: number | undefined;
  displayName?: string | undefined;
  applicationId?: number | undefined;
  isActive?: boolean | undefined;
  isAccessible?: boolean;
}

export class ActionEntitlementResponse implements IActionEntitlementResponse {
  actionEntitlementGroupId?: number | undefined;
  code?: string | undefined;
  description?: string | undefined;
  isActive?: number | undefined;
  isClientEntitlement?: boolean;

  constructor(data?: IActionEntitlementResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.actionEntitlementGroupId = _data['actionEntitlementGroupId'];
      this.code = _data['code'];
      this.description = _data['description'];
      this.isActive = _data['isActive'];
      this.isClientEntitlement = _data['isClientEntitlement'];
    }
  }

  static fromJS(data: any): ActionEntitlementResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ActionEntitlementResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['actionEntitlementGroupId'] = this.actionEntitlementGroupId;
    data['code'] = this.code;
    data['description'] = this.description;
    data['isActive'] = this.isActive;
    data['isClientEntitlement'] = this.isClientEntitlement;
    return data;
  }
}

export interface IActionEntitlementResponse {
  actionEntitlementGroupId?: number | undefined;
  code?: string | undefined;
  description?: string | undefined;
  isActive?: number | undefined;
  isClientEntitlement?: boolean;
}

export class ActivateDeactivateRuleGroupRequest implements IActivateDeactivateRuleGroupRequest {
  isActive?: boolean;

  constructor(data?: IActivateDeactivateRuleGroupRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): ActivateDeactivateRuleGroupRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ActivateDeactivateRuleGroupRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IActivateDeactivateRuleGroupRequest {
  isActive?: boolean;
}

export class ActivateDeactivateRuleRequest implements IActivateDeactivateRuleRequest {
  isActive?: boolean;

  constructor(data?: IActivateDeactivateRuleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): ActivateDeactivateRuleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ActivateDeactivateRuleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IActivateDeactivateRuleRequest {
  isActive?: boolean;
}

export class ActiveReleaseNoteResponse implements IActiveReleaseNoteResponse {
  releaseNoteId?: number;
  version?: string | undefined;
  releaseName?: string | undefined;
  isIncident?: boolean;

  constructor(data?: IActiveReleaseNoteResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.releaseNoteId = _data['releaseNoteId'];
      this.version = _data['version'];
      this.releaseName = _data['releaseName'];
      this.isIncident = _data['isIncident'];
    }
  }

  static fromJS(data: any): ActiveReleaseNoteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ActiveReleaseNoteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['releaseNoteId'] = this.releaseNoteId;
    data['version'] = this.version;
    data['releaseName'] = this.releaseName;
    data['isIncident'] = this.isIncident;
    return data;
  }
}

export interface IActiveReleaseNoteResponse {
  releaseNoteId?: number;
  version?: string | undefined;
  releaseName?: string | undefined;
  isIncident?: boolean;
}

export class ActivityEventTypeResponse implements IActivityEventTypeResponse {
  activityEventTypeId?: number;
  eventTypeCode?: string | undefined;
  eventTypeDescription?: string | undefined;

  constructor(data?: IActivityEventTypeResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.activityEventTypeId = _data['activityEventTypeId'];
      this.eventTypeCode = _data['eventTypeCode'];
      this.eventTypeDescription = _data['eventTypeDescription'];
    }
  }

  static fromJS(data: any): ActivityEventTypeResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ActivityEventTypeResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['activityEventTypeId'] = this.activityEventTypeId;
    data['eventTypeCode'] = this.eventTypeCode;
    data['eventTypeDescription'] = this.eventTypeDescription;
    return data;
  }
}

export interface IActivityEventTypeResponse {
  activityEventTypeId?: number;
  eventTypeCode?: string | undefined;
  eventTypeDescription?: string | undefined;
}

export class ActivityLogDetailItem implements IActivityLogDetailItem {
  stepName!: string;
  stepDescription?: string | undefined;
  status!: string;
  errorMessage?: string | undefined;
  requestPayload?: string | undefined;
  responsePayload?: string | undefined;
  sequenceNo?: number;
  startTime?: string | undefined;
  endTime?: string | undefined;
  durationMs?: number | undefined;

  constructor(data?: IActivityLogDetailItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.stepName = _data['stepName'];
      this.stepDescription = _data['stepDescription'];
      this.status = _data['status'];
      this.errorMessage = _data['errorMessage'];
      this.requestPayload = _data['requestPayload'];
      this.responsePayload = _data['responsePayload'];
      this.sequenceNo = _data['sequenceNo'];
      this.startTime = _data['startTime'];
      this.endTime = _data['endTime'];
      this.durationMs = _data['durationMs'];
    }
  }

  static fromJS(data: any): ActivityLogDetailItem {
    data = typeof data === 'object' ? data : {};
    let result = new ActivityLogDetailItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['stepName'] = this.stepName;
    data['stepDescription'] = this.stepDescription;
    data['status'] = this.status;
    data['errorMessage'] = this.errorMessage;
    data['requestPayload'] = this.requestPayload;
    data['responsePayload'] = this.responsePayload;
    data['sequenceNo'] = this.sequenceNo;
    data['startTime'] = this.startTime;
    data['endTime'] = this.endTime;
    data['durationMs'] = this.durationMs;
    return data;
  }
}

export interface IActivityLogDetailItem {
  stepName: string;
  stepDescription?: string | undefined;
  status: string;
  errorMessage?: string | undefined;
  requestPayload?: string | undefined;
  responsePayload?: string | undefined;
  sequenceNo?: number;
  startTime?: string | undefined;
  endTime?: string | undefined;
  durationMs?: number | undefined;
}

export class ActivityLogDetailResponse implements IActivityLogDetailResponse {
  activityLogDetailId?: number;
  activityLogId?: number;
  stepName?: string | undefined;
  stepDescription?: string | undefined;
  status?: string | undefined;
  errorMessage?: string | undefined;
  requestPayload?: string | undefined;
  responsePayload?: string | undefined;
  sequenceNo?: number;
  startTime?: string | undefined;
  endTime?: string | undefined;
  durationMs?: number | undefined;
  createdDate?: string;

  constructor(data?: IActivityLogDetailResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.activityLogDetailId = _data['activityLogDetailId'];
      this.activityLogId = _data['activityLogId'];
      this.stepName = _data['stepName'];
      this.stepDescription = _data['stepDescription'];
      this.status = _data['status'];
      this.errorMessage = _data['errorMessage'];
      this.requestPayload = _data['requestPayload'];
      this.responsePayload = _data['responsePayload'];
      this.sequenceNo = _data['sequenceNo'];
      this.startTime = _data['startTime'];
      this.endTime = _data['endTime'];
      this.durationMs = _data['durationMs'];
      this.createdDate = _data['createdDate'];
    }
  }

  static fromJS(data: any): ActivityLogDetailResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ActivityLogDetailResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['activityLogDetailId'] = this.activityLogDetailId;
    data['activityLogId'] = this.activityLogId;
    data['stepName'] = this.stepName;
    data['stepDescription'] = this.stepDescription;
    data['status'] = this.status;
    data['errorMessage'] = this.errorMessage;
    data['requestPayload'] = this.requestPayload;
    data['responsePayload'] = this.responsePayload;
    data['sequenceNo'] = this.sequenceNo;
    data['startTime'] = this.startTime;
    data['endTime'] = this.endTime;
    data['durationMs'] = this.durationMs;
    data['createdDate'] = this.createdDate;
    return data;
  }
}

export interface IActivityLogDetailResponse {
  activityLogDetailId?: number;
  activityLogId?: number;
  stepName?: string | undefined;
  stepDescription?: string | undefined;
  status?: string | undefined;
  errorMessage?: string | undefined;
  requestPayload?: string | undefined;
  responsePayload?: string | undefined;
  sequenceNo?: number;
  startTime?: string | undefined;
  endTime?: string | undefined;
  durationMs?: number | undefined;
  createdDate?: string;
}

export class ActivityLogFilterRequest implements IActivityLogFilterRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  userIds?: number[] | undefined;
  moduleIds?: number[] | undefined;
  entityTypeIds?: number[] | undefined;
  activityEventTypeIds?: number[] | undefined;
  userTypeIds?: number[] | undefined;
  searchSort?: SearchSortParams;
  timeZoneId?: string | undefined;

  constructor(data?: IActivityLogFilterRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.fromDate = _data['fromDate'];
      this.toDate = _data['toDate'];
      if (Array.isArray(_data['userIds'])) {
        this.userIds = [] as any;
        for (let item of _data['userIds']) this.userIds!.push(item);
      }
      if (Array.isArray(_data['moduleIds'])) {
        this.moduleIds = [] as any;
        for (let item of _data['moduleIds']) this.moduleIds!.push(item);
      }
      if (Array.isArray(_data['entityTypeIds'])) {
        this.entityTypeIds = [] as any;
        for (let item of _data['entityTypeIds']) this.entityTypeIds!.push(item);
      }
      if (Array.isArray(_data['activityEventTypeIds'])) {
        this.activityEventTypeIds = [] as any;
        for (let item of _data['activityEventTypeIds']) this.activityEventTypeIds!.push(item);
      }
      if (Array.isArray(_data['userTypeIds'])) {
        this.userTypeIds = [] as any;
        for (let item of _data['userTypeIds']) this.userTypeIds!.push(item);
      }
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      this.timeZoneId = _data['timeZoneId'];
    }
  }

  static fromJS(data: any): ActivityLogFilterRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ActivityLogFilterRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['fromDate'] = this.fromDate;
    data['toDate'] = this.toDate;
    if (Array.isArray(this.userIds)) {
      data['userIds'] = [];
      for (let item of this.userIds) data['userIds'].push(item);
    }
    if (Array.isArray(this.moduleIds)) {
      data['moduleIds'] = [];
      for (let item of this.moduleIds) data['moduleIds'].push(item);
    }
    if (Array.isArray(this.entityTypeIds)) {
      data['entityTypeIds'] = [];
      for (let item of this.entityTypeIds) data['entityTypeIds'].push(item);
    }
    if (Array.isArray(this.activityEventTypeIds)) {
      data['activityEventTypeIds'] = [];
      for (let item of this.activityEventTypeIds) data['activityEventTypeIds'].push(item);
    }
    if (Array.isArray(this.userTypeIds)) {
      data['userTypeIds'] = [];
      for (let item of this.userTypeIds) data['userTypeIds'].push(item);
    }
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    data['timeZoneId'] = this.timeZoneId;
    return data;
  }
}

export interface IActivityLogFilterRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  userIds?: number[] | undefined;
  moduleIds?: number[] | undefined;
  entityTypeIds?: number[] | undefined;
  activityEventTypeIds?: number[] | undefined;
  userTypeIds?: number[] | undefined;
  searchSort?: SearchSortParams;
  timeZoneId?: string | undefined;
}

export class ActivityLogResponse implements IActivityLogResponse {
  activityLogId?: number;
  eventTypeCode?: string | undefined;
  moduleId?: number;
  moduleName?: string | undefined;
  actionSummary?: string | undefined;
  entityTypeId?: number | undefined;
  entityTypeName?: string | undefined;
  entityId?: string | undefined;
  userId?: number;
  userName?: string | undefined;
  userEmailAddress?: string | undefined;
  userTypeDescription?: string | undefined;
  createdDate?: string;
  hasDetailLogs?: boolean;

  constructor(data?: IActivityLogResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.activityLogId = _data['activityLogId'];
      this.eventTypeCode = _data['eventTypeCode'];
      this.moduleId = _data['moduleId'];
      this.moduleName = _data['moduleName'];
      this.actionSummary = _data['actionSummary'];
      this.entityTypeId = _data['entityTypeId'];
      this.entityTypeName = _data['entityTypeName'];
      this.entityId = _data['entityId'];
      this.userId = _data['userId'];
      this.userName = _data['userName'];
      this.userEmailAddress = _data['userEmailAddress'];
      this.userTypeDescription = _data['userTypeDescription'];
      this.createdDate = _data['createdDate'];
      this.hasDetailLogs = _data['hasDetailLogs'];
    }
  }

  static fromJS(data: any): ActivityLogResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ActivityLogResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['activityLogId'] = this.activityLogId;
    data['eventTypeCode'] = this.eventTypeCode;
    data['moduleId'] = this.moduleId;
    data['moduleName'] = this.moduleName;
    data['actionSummary'] = this.actionSummary;
    data['entityTypeId'] = this.entityTypeId;
    data['entityTypeName'] = this.entityTypeName;
    data['entityId'] = this.entityId;
    data['userId'] = this.userId;
    data['userName'] = this.userName;
    data['userEmailAddress'] = this.userEmailAddress;
    data['userTypeDescription'] = this.userTypeDescription;
    data['createdDate'] = this.createdDate;
    data['hasDetailLogs'] = this.hasDetailLogs;
    return data;
  }
}

export interface IActivityLogResponse {
  activityLogId?: number;
  eventTypeCode?: string | undefined;
  moduleId?: number;
  moduleName?: string | undefined;
  actionSummary?: string | undefined;
  entityTypeId?: number | undefined;
  entityTypeName?: string | undefined;
  entityId?: string | undefined;
  userId?: number;
  userName?: string | undefined;
  userEmailAddress?: string | undefined;
  userTypeDescription?: string | undefined;
  createdDate?: string;
  hasDetailLogs?: boolean;
}

export class ActivityLogResponsePagedResult implements IActivityLogResponsePagedResult {
  items?: ActivityLogResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IActivityLogResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ActivityLogResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): ActivityLogResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ActivityLogResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IActivityLogResponsePagedResult {
  items?: ActivityLogResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class AddClientRequest implements IAddClientRequest {
  clientId?: number;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  vendorIds?: number[] | undefined;

  constructor(data?: IAddClientRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      if (Array.isArray(_data['lobIds'])) {
        this.lobIds = [] as any;
        for (let item of _data['lobIds']) this.lobIds!.push(item);
      }
      if (Array.isArray(_data['interventionTypeIds'])) {
        this.interventionTypeIds = [] as any;
        for (let item of _data['interventionTypeIds']) this.interventionTypeIds!.push(item);
      }
      if (Array.isArray(_data['vendorIds'])) {
        this.vendorIds = [] as any;
        for (let item of _data['vendorIds']) this.vendorIds!.push(item);
      }
    }
  }

  static fromJS(data: any): AddClientRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AddClientRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    if (Array.isArray(this.lobIds)) {
      data['lobIds'] = [];
      for (let item of this.lobIds) data['lobIds'].push(item);
    }
    if (Array.isArray(this.interventionTypeIds)) {
      data['interventionTypeIds'] = [];
      for (let item of this.interventionTypeIds) data['interventionTypeIds'].push(item);
    }
    if (Array.isArray(this.vendorIds)) {
      data['vendorIds'] = [];
      for (let item of this.vendorIds) data['vendorIds'].push(item);
    }
    return data;
  }
}

export interface IAddClientRequest {
  clientId?: number;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  vendorIds?: number[] | undefined;
}

export class AddClientResponse implements IAddClientResponse {
  clientRowId?: number;
  clientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;
  configurationsCreated?: number;

  constructor(data?: IAddClientResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientRowId = _data['clientRowId'];
      this.clientId = _data['clientId'];
      this.clientName = _data['clientName'];
      this.clientShortName = _data['clientShortName'];
      this.configurationsCreated = _data['configurationsCreated'];
    }
  }

  static fromJS(data: any): AddClientResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AddClientResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientRowId'] = this.clientRowId;
    data['clientId'] = this.clientId;
    data['clientName'] = this.clientName;
    data['clientShortName'] = this.clientShortName;
    data['configurationsCreated'] = this.configurationsCreated;
    return data;
  }
}

export interface IAddClientResponse {
  clientRowId?: number;
  clientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;
  configurationsCreated?: number;
}

export class BulkDeactivateUsersRequest implements IBulkDeactivateUsersRequest {
  userIds!: number[];

  constructor(data?: IBulkDeactivateUsersRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.userIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['userIds'])) {
        this.userIds = [] as any;
        for (let item of _data['userIds']) this.userIds!.push(item);
      }
    }
  }

  static fromJS(data: any): BulkDeactivateUsersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new BulkDeactivateUsersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.userIds)) {
      data['userIds'] = [];
      for (let item of this.userIds) data['userIds'].push(item);
    }
    return data;
  }
}

export interface IBulkDeactivateUsersRequest {
  userIds: number[];
}

export class BulkDeactivateUsersResponse implements IBulkDeactivateUsersResponse {
  totalRequested?: number;
  successCount?: number;
  failureCount?: number;
  successfulUserIds?: number[] | undefined;
  failures?: BulkOperationFailure[] | undefined;
  message?: string | undefined;

  constructor(data?: IBulkDeactivateUsersResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalRequested = _data['totalRequested'];
      this.successCount = _data['successCount'];
      this.failureCount = _data['failureCount'];
      if (Array.isArray(_data['successfulUserIds'])) {
        this.successfulUserIds = [] as any;
        for (let item of _data['successfulUserIds']) this.successfulUserIds!.push(item);
      }
      if (Array.isArray(_data['failures'])) {
        this.failures = [] as any;
        for (let item of _data['failures']) this.failures!.push(BulkOperationFailure.fromJS(item));
      }
      this.message = _data['message'];
    }
  }

  static fromJS(data: any): BulkDeactivateUsersResponse {
    data = typeof data === 'object' ? data : {};
    let result = new BulkDeactivateUsersResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalRequested'] = this.totalRequested;
    data['successCount'] = this.successCount;
    data['failureCount'] = this.failureCount;
    if (Array.isArray(this.successfulUserIds)) {
      data['successfulUserIds'] = [];
      for (let item of this.successfulUserIds) data['successfulUserIds'].push(item);
    }
    if (Array.isArray(this.failures)) {
      data['failures'] = [];
      for (let item of this.failures) data['failures'].push(item ? item.toJSON() : (undefined as any));
    }
    data['message'] = this.message;
    return data;
  }
}

export interface IBulkDeactivateUsersResponse {
  totalRequested?: number;
  successCount?: number;
  failureCount?: number;
  successfulUserIds?: number[] | undefined;
  failures?: BulkOperationFailure[] | undefined;
  message?: string | undefined;
}

export class BulkOperationFailure implements IBulkOperationFailure {
  userId?: number;
  errorMessage?: string | undefined;
  errorType?: string | undefined;

  constructor(data?: IBulkOperationFailure) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.errorMessage = _data['errorMessage'];
      this.errorType = _data['errorType'];
    }
  }

  static fromJS(data: any): BulkOperationFailure {
    data = typeof data === 'object' ? data : {};
    let result = new BulkOperationFailure();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['errorMessage'] = this.errorMessage;
    data['errorType'] = this.errorType;
    return data;
  }
}

export interface IBulkOperationFailure {
  userId?: number;
  errorMessage?: string | undefined;
  errorType?: string | undefined;
}

export class BulkRoleAssignmentRequest implements IBulkRoleAssignmentRequest {
  userIds!: number[];
  userManagementUserIds!: number[];
  roleIds!: number[];

  constructor(data?: IBulkRoleAssignmentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.userIds = [];
      this.userManagementUserIds = [];
      this.roleIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['userIds'])) {
        this.userIds = [] as any;
        for (let item of _data['userIds']) this.userIds!.push(item);
      }
      if (Array.isArray(_data['userManagementUserIds'])) {
        this.userManagementUserIds = [] as any;
        for (let item of _data['userManagementUserIds']) this.userManagementUserIds!.push(item);
      }
      if (Array.isArray(_data['roleIds'])) {
        this.roleIds = [] as any;
        for (let item of _data['roleIds']) this.roleIds!.push(item);
      }
    }
  }

  static fromJS(data: any): BulkRoleAssignmentRequest {
    data = typeof data === 'object' ? data : {};
    let result = new BulkRoleAssignmentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.userIds)) {
      data['userIds'] = [];
      for (let item of this.userIds) data['userIds'].push(item);
    }
    if (Array.isArray(this.userManagementUserIds)) {
      data['userManagementUserIds'] = [];
      for (let item of this.userManagementUserIds) data['userManagementUserIds'].push(item);
    }
    if (Array.isArray(this.roleIds)) {
      data['roleIds'] = [];
      for (let item of this.roleIds) data['roleIds'].push(item);
    }
    return data;
  }
}

export interface IBulkRoleAssignmentRequest {
  userIds: number[];
  userManagementUserIds: number[];
  roleIds: number[];
}

export class BulkRoleAssignmentResponse implements IBulkRoleAssignmentResponse {
  assignmentsCreated?: number;
  assignmentsRemoved?: number;
  assignmentsUpdated?: number;
  usersNotFound?: number;
  rolesNotFound?: number;
  details?: UserAssignmentDetailResponse[] | undefined;

  constructor(data?: IBulkRoleAssignmentResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assignmentsCreated = _data['assignmentsCreated'];
      this.assignmentsRemoved = _data['assignmentsRemoved'];
      this.assignmentsUpdated = _data['assignmentsUpdated'];
      this.usersNotFound = _data['usersNotFound'];
      this.rolesNotFound = _data['rolesNotFound'];
      if (Array.isArray(_data['details'])) {
        this.details = [] as any;
        for (let item of _data['details']) this.details!.push(UserAssignmentDetailResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BulkRoleAssignmentResponse {
    data = typeof data === 'object' ? data : {};
    let result = new BulkRoleAssignmentResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['assignmentsCreated'] = this.assignmentsCreated;
    data['assignmentsRemoved'] = this.assignmentsRemoved;
    data['assignmentsUpdated'] = this.assignmentsUpdated;
    data['usersNotFound'] = this.usersNotFound;
    data['rolesNotFound'] = this.rolesNotFound;
    if (Array.isArray(this.details)) {
      data['details'] = [];
      for (let item of this.details) data['details'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IBulkRoleAssignmentResponse {
  assignmentsCreated?: number;
  assignmentsRemoved?: number;
  assignmentsUpdated?: number;
  usersNotFound?: number;
  rolesNotFound?: number;
  details?: UserAssignmentDetailResponse[] | undefined;
}

export class ClientListRequest implements IClientListRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  searchSort?: SearchSortParams;
  isActive?: boolean | undefined;
  onboardingStatus?: string | undefined;
  lineOfBusinessIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  vendorIds?: number[] | undefined;

  constructor(data?: IClientListRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      this.isActive = _data['isActive'];
      this.onboardingStatus = _data['onboardingStatus'];
      if (Array.isArray(_data['lineOfBusinessIds'])) {
        this.lineOfBusinessIds = [] as any;
        for (let item of _data['lineOfBusinessIds']) this.lineOfBusinessIds!.push(item);
      }
      if (Array.isArray(_data['interventionTypeIds'])) {
        this.interventionTypeIds = [] as any;
        for (let item of _data['interventionTypeIds']) this.interventionTypeIds!.push(item);
      }
      if (Array.isArray(_data['vendorIds'])) {
        this.vendorIds = [] as any;
        for (let item of _data['vendorIds']) this.vendorIds!.push(item);
      }
    }
  }

  static fromJS(data: any): ClientListRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ClientListRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    data['isActive'] = this.isActive;
    data['onboardingStatus'] = this.onboardingStatus;
    if (Array.isArray(this.lineOfBusinessIds)) {
      data['lineOfBusinessIds'] = [];
      for (let item of this.lineOfBusinessIds) data['lineOfBusinessIds'].push(item);
    }
    if (Array.isArray(this.interventionTypeIds)) {
      data['interventionTypeIds'] = [];
      for (let item of this.interventionTypeIds) data['interventionTypeIds'].push(item);
    }
    if (Array.isArray(this.vendorIds)) {
      data['vendorIds'] = [];
      for (let item of this.vendorIds) data['vendorIds'].push(item);
    }
    return data;
  }
}

export interface IClientListRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  searchSort?: SearchSortParams;
  isActive?: boolean | undefined;
  onboardingStatus?: string | undefined;
  lineOfBusinessIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  vendorIds?: number[] | undefined;
}

export class ClientManagementData implements IClientManagementData {
  clientRowId?: number;
  clientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  isActive?: boolean;
  onboardingStatus?: string | undefined;
  onboardingErrorMessage?: string | undefined;
  createdDate?: string | undefined;
  modifiedDate?: string | undefined;
  vendors?: VendorDto[] | undefined;

  constructor(data?: IClientManagementData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientRowId = _data['clientRowId'];
      this.clientId = _data['clientId'];
      this.clientName = _data['clientName'];
      this.clientShortName = _data['clientShortName'];
      if (Array.isArray(_data['lobIds'])) {
        this.lobIds = [] as any;
        for (let item of _data['lobIds']) this.lobIds!.push(item);
      }
      if (Array.isArray(_data['interventionTypeIds'])) {
        this.interventionTypeIds = [] as any;
        for (let item of _data['interventionTypeIds']) this.interventionTypeIds!.push(item);
      }
      this.isActive = _data['isActive'];
      this.onboardingStatus = _data['onboardingStatus'];
      this.onboardingErrorMessage = _data['onboardingErrorMessage'];
      this.createdDate = _data['createdDate'];
      this.modifiedDate = _data['modifiedDate'];
      if (Array.isArray(_data['vendors'])) {
        this.vendors = [] as any;
        for (let item of _data['vendors']) this.vendors!.push(VendorDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClientManagementData {
    data = typeof data === 'object' ? data : {};
    let result = new ClientManagementData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientRowId'] = this.clientRowId;
    data['clientId'] = this.clientId;
    data['clientName'] = this.clientName;
    data['clientShortName'] = this.clientShortName;
    if (Array.isArray(this.lobIds)) {
      data['lobIds'] = [];
      for (let item of this.lobIds) data['lobIds'].push(item);
    }
    if (Array.isArray(this.interventionTypeIds)) {
      data['interventionTypeIds'] = [];
      for (let item of this.interventionTypeIds) data['interventionTypeIds'].push(item);
    }
    data['isActive'] = this.isActive;
    data['onboardingStatus'] = this.onboardingStatus;
    data['onboardingErrorMessage'] = this.onboardingErrorMessage;
    data['createdDate'] = this.createdDate;
    data['modifiedDate'] = this.modifiedDate;
    if (Array.isArray(this.vendors)) {
      data['vendors'] = [];
      for (let item of this.vendors) data['vendors'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IClientManagementData {
  clientRowId?: number;
  clientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  isActive?: boolean;
  onboardingStatus?: string | undefined;
  onboardingErrorMessage?: string | undefined;
  createdDate?: string | undefined;
  modifiedDate?: string | undefined;
  vendors?: VendorDto[] | undefined;
}

export class ClientManagementResponse implements IClientManagementResponse {
  clientRowId?: number;
  codisClientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;
  linesOfBusiness?: number[] | undefined;
  interventions?: number[] | undefined;
  isActive?: boolean;
  vendors?: VendorDto[] | undefined;
  onboardingStatus?: string | undefined;
  onboardingErrorMessage?: string | undefined;

  constructor(data?: IClientManagementResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientRowId = _data['clientRowId'];
      this.codisClientId = _data['codisClientId'];
      this.clientName = _data['clientName'];
      this.clientShortName = _data['clientShortName'];
      if (Array.isArray(_data['linesOfBusiness'])) {
        this.linesOfBusiness = [] as any;
        for (let item of _data['linesOfBusiness']) this.linesOfBusiness!.push(item);
      }
      if (Array.isArray(_data['interventions'])) {
        this.interventions = [] as any;
        for (let item of _data['interventions']) this.interventions!.push(item);
      }
      this.isActive = _data['isActive'];
      if (Array.isArray(_data['vendors'])) {
        this.vendors = [] as any;
        for (let item of _data['vendors']) this.vendors!.push(VendorDto.fromJS(item));
      }
      this.onboardingStatus = _data['onboardingStatus'];
      this.onboardingErrorMessage = _data['onboardingErrorMessage'];
    }
  }

  static fromJS(data: any): ClientManagementResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientManagementResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientRowId'] = this.clientRowId;
    data['codisClientId'] = this.codisClientId;
    data['clientName'] = this.clientName;
    data['clientShortName'] = this.clientShortName;
    if (Array.isArray(this.linesOfBusiness)) {
      data['linesOfBusiness'] = [];
      for (let item of this.linesOfBusiness) data['linesOfBusiness'].push(item);
    }
    if (Array.isArray(this.interventions)) {
      data['interventions'] = [];
      for (let item of this.interventions) data['interventions'].push(item);
    }
    data['isActive'] = this.isActive;
    if (Array.isArray(this.vendors)) {
      data['vendors'] = [];
      for (let item of this.vendors) data['vendors'].push(item ? item.toJSON() : (undefined as any));
    }
    data['onboardingStatus'] = this.onboardingStatus;
    data['onboardingErrorMessage'] = this.onboardingErrorMessage;
    return data;
  }
}

export interface IClientManagementResponse {
  clientRowId?: number;
  codisClientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;
  linesOfBusiness?: number[] | undefined;
  interventions?: number[] | undefined;
  isActive?: boolean;
  vendors?: VendorDto[] | undefined;
  onboardingStatus?: string | undefined;
  onboardingErrorMessage?: string | undefined;
}

export class ClientManagementResponsePagedResult implements IClientManagementResponsePagedResult {
  items?: ClientManagementResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IClientManagementResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ClientManagementResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): ClientManagementResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ClientManagementResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IClientManagementResponsePagedResult {
  items?: ClientManagementResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ClientSpecificTemplateResponse implements IClientSpecificTemplateResponse {
  clientTemplateConfigurationId?: number;
  templateId?: number;
  templateName?: string | undefined;
  templateVersion?: number | undefined;
  lineOfBusiness?: string | undefined;
  interventionType?: string | undefined;
  effectiveStartDate?: string;
  effectiveEndDate?: string | undefined;
  assignedBy?: string | undefined;
  createdDate?: string;
  modifiedDate?: string | undefined;

  constructor(data?: IClientSpecificTemplateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientTemplateConfigurationId = _data['clientTemplateConfigurationId'];
      this.templateId = _data['templateId'];
      this.templateName = _data['templateName'];
      this.templateVersion = _data['templateVersion'];
      this.lineOfBusiness = _data['lineOfBusiness'];
      this.interventionType = _data['interventionType'];
      this.effectiveStartDate = _data['effectiveStartDate'];
      this.effectiveEndDate = _data['effectiveEndDate'];
      this.assignedBy = _data['assignedBy'];
      this.createdDate = _data['createdDate'];
      this.modifiedDate = _data['modifiedDate'];
    }
  }

  static fromJS(data: any): ClientSpecificTemplateResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientSpecificTemplateResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientTemplateConfigurationId'] = this.clientTemplateConfigurationId;
    data['templateId'] = this.templateId;
    data['templateName'] = this.templateName;
    data['templateVersion'] = this.templateVersion;
    data['lineOfBusiness'] = this.lineOfBusiness;
    data['interventionType'] = this.interventionType;
    data['effectiveStartDate'] = this.effectiveStartDate;
    data['effectiveEndDate'] = this.effectiveEndDate;
    data['assignedBy'] = this.assignedBy;
    data['createdDate'] = this.createdDate;
    data['modifiedDate'] = this.modifiedDate;
    return data;
  }
}

export interface IClientSpecificTemplateResponse {
  clientTemplateConfigurationId?: number;
  templateId?: number;
  templateName?: string | undefined;
  templateVersion?: number | undefined;
  lineOfBusiness?: string | undefined;
  interventionType?: string | undefined;
  effectiveStartDate?: string;
  effectiveEndDate?: string | undefined;
  assignedBy?: string | undefined;
  createdDate?: string;
  modifiedDate?: string | undefined;
}

export class CreateActivityLogRequest implements ICreateActivityLogRequest {
  eventTypeCode!: string;
  moduleName!: string;
  entityTypeName!: string;
  actionTemplate!: string;
  entityId?: string | undefined;
  oldValues?: string | undefined;
  newValues?: string | undefined;
  createdDate?: string | undefined;
  activityDetails?: ActivityLogDetailItem[] | undefined;

  constructor(data?: ICreateActivityLogRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventTypeCode = _data['eventTypeCode'];
      this.moduleName = _data['moduleName'];
      this.entityTypeName = _data['entityTypeName'];
      this.actionTemplate = _data['actionTemplate'];
      this.entityId = _data['entityId'];
      this.oldValues = _data['oldValues'];
      this.newValues = _data['newValues'];
      this.createdDate = _data['createdDate'];
      if (Array.isArray(_data['activityDetails'])) {
        this.activityDetails = [] as any;
        for (let item of _data['activityDetails']) this.activityDetails!.push(ActivityLogDetailItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreateActivityLogRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateActivityLogRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['eventTypeCode'] = this.eventTypeCode;
    data['moduleName'] = this.moduleName;
    data['entityTypeName'] = this.entityTypeName;
    data['actionTemplate'] = this.actionTemplate;
    data['entityId'] = this.entityId;
    data['oldValues'] = this.oldValues;
    data['newValues'] = this.newValues;
    data['createdDate'] = this.createdDate;
    if (Array.isArray(this.activityDetails)) {
      data['activityDetails'] = [];
      for (let item of this.activityDetails) data['activityDetails'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICreateActivityLogRequest {
  eventTypeCode: string;
  moduleName: string;
  entityTypeName: string;
  actionTemplate: string;
  entityId?: string | undefined;
  oldValues?: string | undefined;
  newValues?: string | undefined;
  createdDate?: string | undefined;
  activityDetails?: ActivityLogDetailItem[] | undefined;
}

export class CreateReleaseNoteItemRequest implements ICreateReleaseNoteItemRequest {
  type!: string;
  title!: string;
  content!: string;
  displayOrder?: number;

  constructor(data?: ICreateReleaseNoteItemRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.title = _data['title'];
      this.content = _data['content'];
      this.displayOrder = _data['displayOrder'];
    }
  }

  static fromJS(data: any): CreateReleaseNoteItemRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateReleaseNoteItemRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['title'] = this.title;
    data['content'] = this.content;
    data['displayOrder'] = this.displayOrder;
    return data;
  }
}

export interface ICreateReleaseNoteItemRequest {
  type: string;
  title: string;
  content: string;
  displayOrder?: number;
}

export class CreateReleaseNoteRequest implements ICreateReleaseNoteRequest {
  releaseName!: string;
  version!: string;
  description!: string;
  releaseDate!: string;
  startDate!: string;
  endDate!: string;
  statusId!: number;
  items?: CreateReleaseNoteItemRequest[] | undefined;

  constructor(data?: ICreateReleaseNoteRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.releaseName = _data['releaseName'];
      this.version = _data['version'];
      this.description = _data['description'];
      this.releaseDate = _data['releaseDate'];
      this.startDate = _data['startDate'];
      this.endDate = _data['endDate'];
      this.statusId = _data['statusId'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CreateReleaseNoteItemRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreateReleaseNoteRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateReleaseNoteRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['releaseName'] = this.releaseName;
    data['version'] = this.version;
    data['description'] = this.description;
    data['releaseDate'] = this.releaseDate;
    data['startDate'] = this.startDate;
    data['endDate'] = this.endDate;
    data['statusId'] = this.statusId;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICreateReleaseNoteRequest {
  releaseName: string;
  version: string;
  description: string;
  releaseDate: string;
  startDate: string;
  endDate: string;
  statusId: number;
  items?: CreateReleaseNoteItemRequest[] | undefined;
}

export class CreateRuleConflictDefinitionRequest implements ICreateRuleConflictDefinitionRequest {
  conflictType?: RuleConflictType;
  note?: string | undefined;
  displayOrder?: number;
  basket?: string | undefined;
  icdCodes?: string[] | undefined;

  constructor(data?: ICreateRuleConflictDefinitionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conflictType = _data['conflictType'];
      this.note = _data['note'];
      this.displayOrder = _data['displayOrder'];
      this.basket = _data['basket'];
      if (Array.isArray(_data['icdCodes'])) {
        this.icdCodes = [] as any;
        for (let item of _data['icdCodes']) this.icdCodes!.push(item);
      }
    }
  }

  static fromJS(data: any): CreateRuleConflictDefinitionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateRuleConflictDefinitionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['conflictType'] = this.conflictType;
    data['note'] = this.note;
    data['displayOrder'] = this.displayOrder;
    data['basket'] = this.basket;
    if (Array.isArray(this.icdCodes)) {
      data['icdCodes'] = [];
      for (let item of this.icdCodes) data['icdCodes'].push(item);
    }
    return data;
  }
}

export interface ICreateRuleConflictDefinitionRequest {
  conflictType?: RuleConflictType;
  note?: string | undefined;
  displayOrder?: number;
  basket?: string | undefined;
  icdCodes?: string[] | undefined;
}

export class CreateRuleGroupRequest implements ICreateRuleGroupRequest {
  name!: string;
  description?: string | undefined;

  constructor(data?: ICreateRuleGroupRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): CreateRuleGroupRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateRuleGroupRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }
}

export interface ICreateRuleGroupRequest {
  name: string;
  description?: string | undefined;
}

export class CreateRuleRequest implements ICreateRuleRequest {
  ruleGroupId?: number;
  category?: RuleCategory;
  severity?: RuleSeverity;
  matchType?: RuleMatchType;
  icdCodes?: string[] | undefined;
  name!: string;
  whyConflict!: string;
  howToResolve?: string | undefined;
  conflictDefinitions?: CreateRuleConflictDefinitionRequest[] | undefined;

  constructor(data?: ICreateRuleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleGroupId = _data['ruleGroupId'];
      this.category = _data['category'];
      this.severity = _data['severity'];
      this.matchType = _data['matchType'];
      if (Array.isArray(_data['icdCodes'])) {
        this.icdCodes = [] as any;
        for (let item of _data['icdCodes']) this.icdCodes!.push(item);
      }
      this.name = _data['name'];
      this.whyConflict = _data['whyConflict'];
      this.howToResolve = _data['howToResolve'];
      if (Array.isArray(_data['conflictDefinitions'])) {
        this.conflictDefinitions = [] as any;
        for (let item of _data['conflictDefinitions'])
          this.conflictDefinitions!.push(CreateRuleConflictDefinitionRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreateRuleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateRuleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ruleGroupId'] = this.ruleGroupId;
    data['category'] = this.category;
    data['severity'] = this.severity;
    data['matchType'] = this.matchType;
    if (Array.isArray(this.icdCodes)) {
      data['icdCodes'] = [];
      for (let item of this.icdCodes) data['icdCodes'].push(item);
    }
    data['name'] = this.name;
    data['whyConflict'] = this.whyConflict;
    data['howToResolve'] = this.howToResolve;
    if (Array.isArray(this.conflictDefinitions)) {
      data['conflictDefinitions'] = [];
      for (let item of this.conflictDefinitions)
        data['conflictDefinitions'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICreateRuleRequest {
  ruleGroupId?: number;
  category?: RuleCategory;
  severity?: RuleSeverity;
  matchType?: RuleMatchType;
  icdCodes?: string[] | undefined;
  name: string;
  whyConflict: string;
  howToResolve?: string | undefined;
  conflictDefinitions?: CreateRuleConflictDefinitionRequest[] | undefined;
}

export class DeactivateClientResponse implements IDeactivateClientResponse {
  clientRowId?: number;
  clientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;
  message?: string | undefined;

  constructor(data?: IDeactivateClientResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientRowId = _data['clientRowId'];
      this.clientId = _data['clientId'];
      this.clientName = _data['clientName'];
      this.clientShortName = _data['clientShortName'];
      this.message = _data['message'];
    }
  }

  static fromJS(data: any): DeactivateClientResponse {
    data = typeof data === 'object' ? data : {};
    let result = new DeactivateClientResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientRowId'] = this.clientRowId;
    data['clientId'] = this.clientId;
    data['clientName'] = this.clientName;
    data['clientShortName'] = this.clientShortName;
    data['message'] = this.message;
    return data;
  }
}

export interface IDeactivateClientResponse {
  clientRowId?: number;
  clientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;
  message?: string | undefined;
}

export class EntityTypeResponse implements IEntityTypeResponse {
  entityTypeId?: number;
  entityTypeName?: string | undefined;
  isDeleted?: boolean;

  constructor(data?: IEntityTypeResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityTypeId = _data['entityTypeId'];
      this.entityTypeName = _data['entityTypeName'];
      this.isDeleted = _data['isDeleted'];
    }
  }

  static fromJS(data: any): EntityTypeResponse {
    data = typeof data === 'object' ? data : {};
    let result = new EntityTypeResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['entityTypeId'] = this.entityTypeId;
    data['entityTypeName'] = this.entityTypeName;
    data['isDeleted'] = this.isDeleted;
    return data;
  }
}

export interface IEntityTypeResponse {
  entityTypeId?: number;
  entityTypeName?: string | undefined;
  isDeleted?: boolean;
}

export class GetUsersRequest implements IGetUsersRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  searchSort?: SearchSortParams;
  clientIds?: string | undefined;
  applicationName?: string | undefined;

  constructor(data?: IGetUsersRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      this.clientIds = _data['clientIds'];
      this.applicationName = _data['applicationName'];
    }
  }

  static fromJS(data: any): GetUsersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new GetUsersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    data['clientIds'] = this.clientIds;
    data['applicationName'] = this.applicationName;
    return data;
  }
}

export interface IGetUsersRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  searchSort?: SearchSortParams;
  clientIds?: string | undefined;
  applicationName?: string | undefined;
}

export class GetUsersResultResponse implements IGetUsersResultResponse {
  id?: number;
  userName?: string | undefined;
  clientId?: number | undefined;
  isActive?: boolean | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  redeemStatus?: boolean | undefined;
  activationStatus?: boolean | undefined;
  applicationId?: number | undefined;
  applicationShortName?: string | undefined;

  constructor(data?: IGetUsersResultResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.clientId = _data['clientId'];
      this.isActive = _data['isActive'];
      this.phoneNumber = _data['phoneNumber'];
      this.emailAddress = _data['emailAddress'];
      this.redeemStatus = _data['redeemStatus'];
      this.activationStatus = _data['activationStatus'];
      this.applicationId = _data['applicationId'];
      this.applicationShortName = _data['applicationShortName'];
    }
  }

  static fromJS(data: any): GetUsersResultResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetUsersResultResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['clientId'] = this.clientId;
    data['isActive'] = this.isActive;
    data['phoneNumber'] = this.phoneNumber;
    data['emailAddress'] = this.emailAddress;
    data['redeemStatus'] = this.redeemStatus;
    data['activationStatus'] = this.activationStatus;
    data['applicationId'] = this.applicationId;
    data['applicationShortName'] = this.applicationShortName;
    return data;
  }
}

export interface IGetUsersResultResponse {
  id?: number;
  userName?: string | undefined;
  clientId?: number | undefined;
  isActive?: boolean | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  redeemStatus?: boolean | undefined;
  activationStatus?: boolean | undefined;
  applicationId?: number | undefined;
  applicationShortName?: string | undefined;
}

export class GetUsersResultResponsePagedResult implements IGetUsersResultResponsePagedResult {
  items?: GetUsersResultResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IGetUsersResultResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(GetUsersResultResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): GetUsersResultResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new GetUsersResultResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IGetUsersResultResponsePagedResult {
  items?: GetUsersResultResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class HealthCheckResponse implements IHealthCheckResponse {
  status?: string | undefined;
  timestamp?: string;
  version?: string | undefined;
  environment?: string | undefined;
  details?: { [key: string]: string } | undefined;

  constructor(data?: IHealthCheckResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data['status'];
      this.timestamp = _data['timestamp'];
      this.version = _data['version'];
      this.environment = _data['environment'];
      if (_data['details']) {
        this.details = {} as any;
        for (let key in _data['details']) {
          if (_data['details'].hasOwnProperty(key)) (this.details as any)![key] = _data['details'][key];
        }
      }
    }
  }

  static fromJS(data: any): HealthCheckResponse {
    data = typeof data === 'object' ? data : {};
    let result = new HealthCheckResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['status'] = this.status;
    data['timestamp'] = this.timestamp;
    data['version'] = this.version;
    data['environment'] = this.environment;
    if (this.details) {
      data['details'] = {};
      for (let key in this.details) {
        if (this.details.hasOwnProperty(key)) (data['details'] as any)[key] = (this.details as any)[key];
      }
    }
    return data;
  }
}

export interface IHealthCheckResponse {
  status?: string | undefined;
  timestamp?: string;
  version?: string | undefined;
  environment?: string | undefined;
  details?: { [key: string]: string } | undefined;
}

export class ImpersonationStartRequest implements IImpersonationStartRequest {
  impersonatedUserEmail!: string;

  constructor(data?: IImpersonationStartRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.impersonatedUserEmail = _data['impersonatedUserEmail'];
    }
  }

  static fromJS(data: any): ImpersonationStartRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonationStartRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['impersonatedUserEmail'] = this.impersonatedUserEmail;
    return data;
  }
}

export interface IImpersonationStartRequest {
  impersonatedUserEmail: string;
}

export class ImpersonationStartResponse implements IImpersonationStartResponse {
  accessToken?: string | undefined;
  tokenType?: string | undefined;
  expiresIn?: number;
  impersonatedUserEmail?: string | undefined;

  constructor(data?: IImpersonationStartResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data['accessToken'];
      this.tokenType = _data['tokenType'];
      this.expiresIn = _data['expiresIn'];
      this.impersonatedUserEmail = _data['impersonatedUserEmail'];
    }
  }

  static fromJS(data: any): ImpersonationStartResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonationStartResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['accessToken'] = this.accessToken;
    data['tokenType'] = this.tokenType;
    data['expiresIn'] = this.expiresIn;
    data['impersonatedUserEmail'] = this.impersonatedUserEmail;
    return data;
  }
}

export interface IImpersonationStartResponse {
  accessToken?: string | undefined;
  tokenType?: string | undefined;
  expiresIn?: number;
  impersonatedUserEmail?: string | undefined;
}

export class ImpersonationStopRequest implements IImpersonationStopRequest {
  impersonatedUserEmail!: string;
  impersonatedTokenId!: string;

  constructor(data?: IImpersonationStopRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.impersonatedUserEmail = _data['impersonatedUserEmail'];
      this.impersonatedTokenId = _data['impersonatedTokenId'];
    }
  }

  static fromJS(data: any): ImpersonationStopRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonationStopRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['impersonatedUserEmail'] = this.impersonatedUserEmail;
    data['impersonatedTokenId'] = this.impersonatedTokenId;
    return data;
  }
}

export interface IImpersonationStopRequest {
  impersonatedUserEmail: string;
  impersonatedTokenId: string;
}

export class ImpersonationStopResponse implements IImpersonationStopResponse {
  success?: boolean;
  message?: string | undefined;
  impersonatedUserEmail?: string | undefined;

  constructor(data?: IImpersonationStopResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data['success'];
      this.message = _data['message'];
      this.impersonatedUserEmail = _data['impersonatedUserEmail'];
    }
  }

  static fromJS(data: any): ImpersonationStopResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonationStopResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['success'] = this.success;
    data['message'] = this.message;
    data['impersonatedUserEmail'] = this.impersonatedUserEmail;
    return data;
  }
}

export interface IImpersonationStopResponse {
  success?: boolean;
  message?: string | undefined;
  impersonatedUserEmail?: string | undefined;
}

export class ModuleResponse implements IModuleResponse {
  moduleId?: number;
  moduleName?: string | undefined;
  isDeleted?: boolean;

  constructor(data?: IModuleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.moduleId = _data['moduleId'];
      this.moduleName = _data['moduleName'];
      this.isDeleted = _data['isDeleted'];
    }
  }

  static fromJS(data: any): ModuleResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ModuleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['moduleId'] = this.moduleId;
    data['moduleName'] = this.moduleName;
    data['isDeleted'] = this.isDeleted;
    return data;
  }
}

export interface IModuleResponse {
  moduleId?: number;
  moduleName?: string | undefined;
  isDeleted?: boolean;
}

/** Response model for retrieving the offline PIN hash for a nurse practitioner. */
export class NursePractitionerPinResponse implements INursePractitionerPinResponse {
  /** Gets the offline PIN hash (SHA-256 hex string) for the nurse practitioner. */
  pinHash?: string | undefined;
  /** Gets the nurse practitioner ID. */
  nursePractitionerId?: number;
  /** Gets the first name of the nurse practitioner. */
  firstName?: string | undefined;
  /** Gets the last name of the nurse practitioner. */
  lastName?: string | undefined;

  constructor(data?: INursePractitionerPinResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pinHash = _data['pinHash'];
      this.nursePractitionerId = _data['nursePractitionerId'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
    }
  }

  static fromJS(data: any): NursePractitionerPinResponse {
    data = typeof data === 'object' ? data : {};
    let result = new NursePractitionerPinResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['pinHash'] = this.pinHash;
    data['nursePractitionerId'] = this.nursePractitionerId;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    return data;
  }
}

/** Response model for retrieving the offline PIN hash for a nurse practitioner. */
export interface INursePractitionerPinResponse {
  /** Gets the offline PIN hash (SHA-256 hex string) for the nurse practitioner. */
  pinHash?: string | undefined;
  /** Gets the nurse practitioner ID. */
  nursePractitionerId?: number;
  /** Gets the first name of the nurse practitioner. */
  firstName?: string | undefined;
  /** Gets the last name of the nurse practitioner. */
  lastName?: string | undefined;
}

export class PermissionGroupNodeResponse implements IPermissionGroupNodeResponse {
  groupId?: number;
  groupName?: string | undefined;
  displayName?: string | undefined;
  children?: PermissionGroupNodeResponse[] | undefined;
  permissions?: PermissionItemResponse[] | undefined;

  constructor(data?: IPermissionGroupNodeResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.groupId = _data['groupId'];
      this.groupName = _data['groupName'];
      this.displayName = _data['displayName'];
      if (Array.isArray(_data['children'])) {
        this.children = [] as any;
        for (let item of _data['children']) this.children!.push(PermissionGroupNodeResponse.fromJS(item));
      }
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(PermissionItemResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PermissionGroupNodeResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PermissionGroupNodeResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['groupId'] = this.groupId;
    data['groupName'] = this.groupName;
    data['displayName'] = this.displayName;
    if (Array.isArray(this.children)) {
      data['children'] = [];
      for (let item of this.children) data['children'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IPermissionGroupNodeResponse {
  groupId?: number;
  groupName?: string | undefined;
  displayName?: string | undefined;
  children?: PermissionGroupNodeResponse[] | undefined;
  permissions?: PermissionItemResponse[] | undefined;
}

export class PermissionItemResponse implements IPermissionItemResponse {
  code?: string | undefined;
  description?: string | undefined;
  groupId?: number;
  isAssigned?: boolean;

  constructor(data?: IPermissionItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data['code'];
      this.description = _data['description'];
      this.groupId = _data['groupId'];
      this.isAssigned = _data['isAssigned'];
    }
  }

  static fromJS(data: any): PermissionItemResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PermissionItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['description'] = this.description;
    data['groupId'] = this.groupId;
    data['isAssigned'] = this.isAssigned;
    return data;
  }
}

export interface IPermissionItemResponse {
  code?: string | undefined;
  description?: string | undefined;
  groupId?: number;
  isAssigned?: boolean;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class ReleaseNoteItemResponse implements IReleaseNoteItemResponse {
  itemId?: number;
  type?: string | undefined;
  title?: string | undefined;
  content?: string | undefined;
  displayOrder?: number;

  constructor(data?: IReleaseNoteItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.itemId = _data['itemId'];
      this.type = _data['type'];
      this.title = _data['title'];
      this.content = _data['content'];
      this.displayOrder = _data['displayOrder'];
    }
  }

  static fromJS(data: any): ReleaseNoteItemResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ReleaseNoteItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['itemId'] = this.itemId;
    data['type'] = this.type;
    data['title'] = this.title;
    data['content'] = this.content;
    data['displayOrder'] = this.displayOrder;
    return data;
  }
}

export interface IReleaseNoteItemResponse {
  itemId?: number;
  type?: string | undefined;
  title?: string | undefined;
  content?: string | undefined;
  displayOrder?: number;
}

export class ReleaseNoteResponse implements IReleaseNoteResponse {
  releaseNoteId?: number;
  releaseName?: string | undefined;
  version?: string | undefined;
  description?: string | undefined;
  startDate?: string;
  endDate?: string;
  releaseDate?: string;
  statusId?: number;
  statusName?: string | undefined;
  statusCode?: string | undefined;
  isActive?: boolean;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string;
  publishedBy?: string | undefined;
  publishedDate?: string | undefined;
  isEditable?: boolean;
  items?: ReleaseNoteItemResponse[] | undefined;

  constructor(data?: IReleaseNoteResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.releaseNoteId = _data['releaseNoteId'];
      this.releaseName = _data['releaseName'];
      this.version = _data['version'];
      this.description = _data['description'];
      this.startDate = _data['startDate'];
      this.endDate = _data['endDate'];
      this.releaseDate = _data['releaseDate'];
      this.statusId = _data['statusId'];
      this.statusName = _data['statusName'];
      this.statusCode = _data['statusCode'];
      this.isActive = _data['isActive'];
      this.createdBy = _data['createdBy'];
      this.createdDate = _data['createdDate'];
      this.modifiedBy = _data['modifiedBy'];
      this.modifiedDate = _data['modifiedDate'];
      this.publishedBy = _data['publishedBy'];
      this.publishedDate = _data['publishedDate'];
      this.isEditable = _data['isEditable'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ReleaseNoteItemResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ReleaseNoteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ReleaseNoteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['releaseNoteId'] = this.releaseNoteId;
    data['releaseName'] = this.releaseName;
    data['version'] = this.version;
    data['description'] = this.description;
    data['startDate'] = this.startDate;
    data['endDate'] = this.endDate;
    data['releaseDate'] = this.releaseDate;
    data['statusId'] = this.statusId;
    data['statusName'] = this.statusName;
    data['statusCode'] = this.statusCode;
    data['isActive'] = this.isActive;
    data['createdBy'] = this.createdBy;
    data['createdDate'] = this.createdDate;
    data['modifiedBy'] = this.modifiedBy;
    data['modifiedDate'] = this.modifiedDate;
    data['publishedBy'] = this.publishedBy;
    data['publishedDate'] = this.publishedDate;
    data['isEditable'] = this.isEditable;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IReleaseNoteResponse {
  releaseNoteId?: number;
  releaseName?: string | undefined;
  version?: string | undefined;
  description?: string | undefined;
  startDate?: string;
  endDate?: string;
  releaseDate?: string;
  statusId?: number;
  statusName?: string | undefined;
  statusCode?: string | undefined;
  isActive?: boolean;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string;
  publishedBy?: string | undefined;
  publishedDate?: string | undefined;
  isEditable?: boolean;
  items?: ReleaseNoteItemResponse[] | undefined;
}

export class ReleaseNoteResponsePagedResult implements IReleaseNoteResponsePagedResult {
  items?: ReleaseNoteResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IReleaseNoteResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ReleaseNoteResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): ReleaseNoteResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ReleaseNoteResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IReleaseNoteResponsePagedResult {
  items?: ReleaseNoteResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ReleaseNoteSearchRequest implements IReleaseNoteSearchRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  searchSort?: SearchSortParams;

  constructor(data?: IReleaseNoteSearchRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
    }
  }

  static fromJS(data: any): ReleaseNoteSearchRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ReleaseNoteSearchRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    return data;
  }
}

export interface IReleaseNoteSearchRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  searchSort?: SearchSortParams;
}

export class ReleaseNoteTimelineResponse implements IReleaseNoteTimelineResponse {
  releaseNoteId?: number;
  releaseName?: string | undefined;
  version?: string | undefined;
  description?: string | undefined;
  releaseDate?: string;

  constructor(data?: IReleaseNoteTimelineResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.releaseNoteId = _data['releaseNoteId'];
      this.releaseName = _data['releaseName'];
      this.version = _data['version'];
      this.description = _data['description'];
      this.releaseDate = _data['releaseDate'];
    }
  }

  static fromJS(data: any): ReleaseNoteTimelineResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ReleaseNoteTimelineResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['releaseNoteId'] = this.releaseNoteId;
    data['releaseName'] = this.releaseName;
    data['version'] = this.version;
    data['description'] = this.description;
    data['releaseDate'] = this.releaseDate;
    return data;
  }
}

export interface IReleaseNoteTimelineResponse {
  releaseNoteId?: number;
  releaseName?: string | undefined;
  version?: string | undefined;
  description?: string | undefined;
  releaseDate?: string;
}

export class ReleaseNoteViewResponse implements IReleaseNoteViewResponse {
  releaseNoteId?: number;
  releaseName?: string | undefined;
  version?: string | undefined;
  description?: string | undefined;
  releaseDate?: string;
  items?: ReleaseNoteItemResponse[] | undefined;

  constructor(data?: IReleaseNoteViewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.releaseNoteId = _data['releaseNoteId'];
      this.releaseName = _data['releaseName'];
      this.version = _data['version'];
      this.description = _data['description'];
      this.releaseDate = _data['releaseDate'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ReleaseNoteItemResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ReleaseNoteViewResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ReleaseNoteViewResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['releaseNoteId'] = this.releaseNoteId;
    data['releaseName'] = this.releaseName;
    data['version'] = this.version;
    data['description'] = this.description;
    data['releaseDate'] = this.releaseDate;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IReleaseNoteViewResponse {
  releaseNoteId?: number;
  releaseName?: string | undefined;
  version?: string | undefined;
  description?: string | undefined;
  releaseDate?: string;
  items?: ReleaseNoteItemResponse[] | undefined;
}

export class RoleActionEntitlementCreateRequest implements IRoleActionEntitlementCreateRequest {
  roleId!: number;
  code!: string;

  constructor(data?: IRoleActionEntitlementCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId'];
      this.code = _data['code'];
    }
  }

  static fromJS(data: any): RoleActionEntitlementCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RoleActionEntitlementCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['roleId'] = this.roleId;
    data['code'] = this.code;
    return data;
  }
}

export interface IRoleActionEntitlementCreateRequest {
  roleId: number;
  code: string;
}

export class RoleActionEntitlementResponse implements IRoleActionEntitlementResponse {
  id?: number;
  roleId?: number | undefined;
  code?: string | undefined;

  constructor(data?: IRoleActionEntitlementResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.roleId = _data['roleId'];
      this.code = _data['code'];
    }
  }

  static fromJS(data: any): RoleActionEntitlementResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RoleActionEntitlementResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['roleId'] = this.roleId;
    data['code'] = this.code;
    return data;
  }
}

export interface IRoleActionEntitlementResponse {
  id?: number;
  roleId?: number | undefined;
  code?: string | undefined;
}

export class RoleCreateRequest implements IRoleCreateRequest {
  shortName!: string;
  fullName!: string;
  isActive?: boolean | undefined;
  isInternal?: boolean | undefined;

  constructor(data?: IRoleCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.shortName = _data['shortName'];
      this.fullName = _data['fullName'];
      this.isActive = _data['isActive'];
      this.isInternal = _data['isInternal'];
    }
  }

  static fromJS(data: any): RoleCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RoleCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['shortName'] = this.shortName;
    data['fullName'] = this.fullName;
    data['isActive'] = this.isActive;
    data['isInternal'] = this.isInternal;
    return data;
  }
}

export interface IRoleCreateRequest {
  shortName: string;
  fullName: string;
  isActive?: boolean | undefined;
  isInternal?: boolean | undefined;
}

export class RoleItemResponse implements IRoleItemResponse {
  roleId?: number;
  roleName?: string | undefined;

  constructor(data?: IRoleItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
    }
  }

  static fromJS(data: any): RoleItemResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RoleItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    return data;
  }
}

export interface IRoleItemResponse {
  roleId?: number;
  roleName?: string | undefined;
}

export class RoleResponse implements IRoleResponse {
  id?: number;
  shortName?: string | undefined;
  fullName?: string | undefined;
  applicationId?: number;
  isActive?: boolean | undefined;
  isInternal?: boolean | undefined;
  userCount?: number;
  users?: RoleUserResponse[] | undefined;

  constructor(data?: IRoleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.shortName = _data['shortName'];
      this.fullName = _data['fullName'];
      this.applicationId = _data['applicationId'];
      this.isActive = _data['isActive'];
      this.isInternal = _data['isInternal'];
      this.userCount = _data['userCount'];
      if (Array.isArray(_data['users'])) {
        this.users = [] as any;
        for (let item of _data['users']) this.users!.push(RoleUserResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RoleResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RoleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['shortName'] = this.shortName;
    data['fullName'] = this.fullName;
    data['applicationId'] = this.applicationId;
    data['isActive'] = this.isActive;
    data['isInternal'] = this.isInternal;
    data['userCount'] = this.userCount;
    if (Array.isArray(this.users)) {
      data['users'] = [];
      for (let item of this.users) data['users'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IRoleResponse {
  id?: number;
  shortName?: string | undefined;
  fullName?: string | undefined;
  applicationId?: number;
  isActive?: boolean | undefined;
  isInternal?: boolean | undefined;
  userCount?: number;
  users?: RoleUserResponse[] | undefined;
}

export class RoleUpdateRequest implements IRoleUpdateRequest {
  id?: number;
  shortName!: string;
  fullName!: string;
  isActive?: boolean | undefined;
  isInternal?: boolean | undefined;

  constructor(data?: IRoleUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.shortName = _data['shortName'];
      this.fullName = _data['fullName'];
      this.isActive = _data['isActive'];
      this.isInternal = _data['isInternal'];
    }
  }

  static fromJS(data: any): RoleUpdateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RoleUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['shortName'] = this.shortName;
    data['fullName'] = this.fullName;
    data['isActive'] = this.isActive;
    data['isInternal'] = this.isInternal;
    return data;
  }
}

export interface IRoleUpdateRequest {
  id?: number;
  shortName: string;
  fullName: string;
  isActive?: boolean | undefined;
  isInternal?: boolean | undefined;
}

export class RoleUserResponse implements IRoleUserResponse {
  id?: number;
  userName?: string | undefined;
  emailAddress?: string | undefined;
  isActive?: boolean | undefined;

  constructor(data?: IRoleUserResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.emailAddress = _data['emailAddress'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): RoleUserResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RoleUserResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['emailAddress'] = this.emailAddress;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IRoleUserResponse {
  id?: number;
  userName?: string | undefined;
  emailAddress?: string | undefined;
  isActive?: boolean | undefined;
}

export enum RuleCategory {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class RuleConflictDefinitionDetailResponse implements IRuleConflictDefinitionDetailResponse {
  conflictDefinitionId?: number;
  conflictType?: RuleConflictType;
  note?: string | undefined;
  displayOrder?: number;
  icdCodes?: RuleDetailIcdCodeResponse[] | undefined;

  constructor(data?: IRuleConflictDefinitionDetailResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conflictDefinitionId = _data['conflictDefinitionId'];
      this.conflictType = _data['conflictType'];
      this.note = _data['note'];
      this.displayOrder = _data['displayOrder'];
      if (Array.isArray(_data['icdCodes'])) {
        this.icdCodes = [] as any;
        for (let item of _data['icdCodes']) this.icdCodes!.push(RuleDetailIcdCodeResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RuleConflictDefinitionDetailResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RuleConflictDefinitionDetailResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['conflictDefinitionId'] = this.conflictDefinitionId;
    data['conflictType'] = this.conflictType;
    data['note'] = this.note;
    data['displayOrder'] = this.displayOrder;
    if (Array.isArray(this.icdCodes)) {
      data['icdCodes'] = [];
      for (let item of this.icdCodes) data['icdCodes'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IRuleConflictDefinitionDetailResponse {
  conflictDefinitionId?: number;
  conflictType?: RuleConflictType;
  note?: string | undefined;
  displayOrder?: number;
  icdCodes?: RuleDetailIcdCodeResponse[] | undefined;
}

export enum RuleConflictType {
  _1 = 1,
  _2 = 2,
}

export class RuleDetailIcdCodeResponse implements IRuleDetailIcdCodeResponse {
  code?: string | undefined;
  basket?: string | undefined;
  displayOrder?: number;

  constructor(data?: IRuleDetailIcdCodeResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data['code'];
      this.basket = _data['basket'];
      this.displayOrder = _data['displayOrder'];
    }
  }

  static fromJS(data: any): RuleDetailIcdCodeResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RuleDetailIcdCodeResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['basket'] = this.basket;
    data['displayOrder'] = this.displayOrder;
    return data;
  }
}

export interface IRuleDetailIcdCodeResponse {
  code?: string | undefined;
  basket?: string | undefined;
  displayOrder?: number;
}

export class RuleDetailResponse implements IRuleDetailResponse {
  ruleId?: number;
  ruleGroupId?: number;
  groupName?: string | undefined;
  category?: RuleCategory;
  severity?: RuleSeverity;
  matchType?: RuleMatchType;
  name?: string | undefined;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  status?: string | undefined;
  isActive?: boolean;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
  icdCodes?: RuleDetailIcdCodeResponse[] | undefined;
  conflictDefinitions?: RuleConflictDefinitionDetailResponse[] | undefined;

  constructor(data?: IRuleDetailResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleId = _data['ruleId'];
      this.ruleGroupId = _data['ruleGroupId'];
      this.groupName = _data['groupName'];
      this.category = _data['category'];
      this.severity = _data['severity'];
      this.matchType = _data['matchType'];
      this.name = _data['name'];
      this.whyConflict = _data['whyConflict'];
      this.howToResolve = _data['howToResolve'];
      this.status = _data['status'];
      this.isActive = _data['isActive'];
      this.createdBy = _data['createdBy'];
      this.createdDate = _data['createdDate'];
      this.modifiedBy = _data['modifiedBy'];
      this.modifiedDate = _data['modifiedDate'];
      if (Array.isArray(_data['icdCodes'])) {
        this.icdCodes = [] as any;
        for (let item of _data['icdCodes']) this.icdCodes!.push(RuleDetailIcdCodeResponse.fromJS(item));
      }
      if (Array.isArray(_data['conflictDefinitions'])) {
        this.conflictDefinitions = [] as any;
        for (let item of _data['conflictDefinitions'])
          this.conflictDefinitions!.push(RuleConflictDefinitionDetailResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RuleDetailResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RuleDetailResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ruleId'] = this.ruleId;
    data['ruleGroupId'] = this.ruleGroupId;
    data['groupName'] = this.groupName;
    data['category'] = this.category;
    data['severity'] = this.severity;
    data['matchType'] = this.matchType;
    data['name'] = this.name;
    data['whyConflict'] = this.whyConflict;
    data['howToResolve'] = this.howToResolve;
    data['status'] = this.status;
    data['isActive'] = this.isActive;
    data['createdBy'] = this.createdBy;
    data['createdDate'] = this.createdDate;
    data['modifiedBy'] = this.modifiedBy;
    data['modifiedDate'] = this.modifiedDate;
    if (Array.isArray(this.icdCodes)) {
      data['icdCodes'] = [];
      for (let item of this.icdCodes) data['icdCodes'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.conflictDefinitions)) {
      data['conflictDefinitions'] = [];
      for (let item of this.conflictDefinitions)
        data['conflictDefinitions'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IRuleDetailResponse {
  ruleId?: number;
  ruleGroupId?: number;
  groupName?: string | undefined;
  category?: RuleCategory;
  severity?: RuleSeverity;
  matchType?: RuleMatchType;
  name?: string | undefined;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  status?: string | undefined;
  isActive?: boolean;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
  icdCodes?: RuleDetailIcdCodeResponse[] | undefined;
  conflictDefinitions?: RuleConflictDefinitionDetailResponse[] | undefined;
}

export class RuleDetailResponsePagedResult implements IRuleDetailResponsePagedResult {
  items?: RuleDetailResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IRuleDetailResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(RuleDetailResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): RuleDetailResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new RuleDetailResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IRuleDetailResponsePagedResult {
  items?: RuleDetailResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class RuleGroupDetailResponse implements IRuleGroupDetailResponse {
  ruleGroupId?: number;
  name?: string | undefined;
  description?: string | undefined;
  isActive?: boolean;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
  rules?: RuleResponse[] | undefined;

  constructor(data?: IRuleGroupDetailResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleGroupId = _data['ruleGroupId'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.isActive = _data['isActive'];
      this.createdBy = _data['createdBy'];
      this.createdDate = _data['createdDate'];
      this.modifiedBy = _data['modifiedBy'];
      this.modifiedDate = _data['modifiedDate'];
      if (Array.isArray(_data['rules'])) {
        this.rules = [] as any;
        for (let item of _data['rules']) this.rules!.push(RuleResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RuleGroupDetailResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RuleGroupDetailResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ruleGroupId'] = this.ruleGroupId;
    data['name'] = this.name;
    data['description'] = this.description;
    data['isActive'] = this.isActive;
    data['createdBy'] = this.createdBy;
    data['createdDate'] = this.createdDate;
    data['modifiedBy'] = this.modifiedBy;
    data['modifiedDate'] = this.modifiedDate;
    if (Array.isArray(this.rules)) {
      data['rules'] = [];
      for (let item of this.rules) data['rules'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IRuleGroupDetailResponse {
  ruleGroupId?: number;
  name?: string | undefined;
  description?: string | undefined;
  isActive?: boolean;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
  rules?: RuleResponse[] | undefined;
}

export class RuleGroupResponse implements IRuleGroupResponse {
  ruleGroupId?: number;
  name?: string | undefined;
  description?: string | undefined;
  isActive?: boolean;
  rulesCount?: number;
  activeRulesCount?: number;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;

  constructor(data?: IRuleGroupResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleGroupId = _data['ruleGroupId'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.isActive = _data['isActive'];
      this.rulesCount = _data['rulesCount'];
      this.activeRulesCount = _data['activeRulesCount'];
      this.createdBy = _data['createdBy'];
      this.createdDate = _data['createdDate'];
      this.modifiedBy = _data['modifiedBy'];
      this.modifiedDate = _data['modifiedDate'];
    }
  }

  static fromJS(data: any): RuleGroupResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RuleGroupResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ruleGroupId'] = this.ruleGroupId;
    data['name'] = this.name;
    data['description'] = this.description;
    data['isActive'] = this.isActive;
    data['rulesCount'] = this.rulesCount;
    data['activeRulesCount'] = this.activeRulesCount;
    data['createdBy'] = this.createdBy;
    data['createdDate'] = this.createdDate;
    data['modifiedBy'] = this.modifiedBy;
    data['modifiedDate'] = this.modifiedDate;
    return data;
  }
}

export interface IRuleGroupResponse {
  ruleGroupId?: number;
  name?: string | undefined;
  description?: string | undefined;
  isActive?: boolean;
  rulesCount?: number;
  activeRulesCount?: number;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
}

export class RuleGroupResponsePagedResult implements IRuleGroupResponsePagedResult {
  items?: RuleGroupResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IRuleGroupResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(RuleGroupResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): RuleGroupResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new RuleGroupResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IRuleGroupResponsePagedResult {
  items?: RuleGroupResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class RuleGroupSearchRequest implements IRuleGroupSearchRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  searchSort?: SearchSortParams;
  isActive?: boolean | undefined;

  constructor(data?: IRuleGroupSearchRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): RuleGroupSearchRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RuleGroupSearchRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IRuleGroupSearchRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  searchSort?: SearchSortParams;
  isActive?: boolean | undefined;
}

export enum RuleMatchType {
  _1 = 1,
}

export class RuleQueryRequest implements IRuleQueryRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  ruleGroupId!: number;
  searchSort?: SearchSortParams;
  isActive?: boolean | undefined;
  severity?: RuleSeverity;
  category?: RuleCategory;

  constructor(data?: IRuleQueryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.ruleGroupId = _data['ruleGroupId'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      this.isActive = _data['isActive'];
      this.severity = _data['severity'];
      this.category = _data['category'];
    }
  }

  static fromJS(data: any): RuleQueryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RuleQueryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['ruleGroupId'] = this.ruleGroupId;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    data['isActive'] = this.isActive;
    data['severity'] = this.severity;
    data['category'] = this.category;
    return data;
  }
}

export interface IRuleQueryRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  ruleGroupId: number;
  searchSort?: SearchSortParams;
  isActive?: boolean | undefined;
  severity?: RuleSeverity;
  category?: RuleCategory;
}

export class RuleResponse implements IRuleResponse {
  ruleId?: number;
  ruleGroupId?: number;
  category?: RuleCategory;
  severity?: RuleSeverity;
  name?: string | undefined;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  status?: string | undefined;
  isActive?: boolean;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;

  constructor(data?: IRuleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleId = _data['ruleId'];
      this.ruleGroupId = _data['ruleGroupId'];
      this.category = _data['category'];
      this.severity = _data['severity'];
      this.name = _data['name'];
      this.whyConflict = _data['whyConflict'];
      this.howToResolve = _data['howToResolve'];
      this.status = _data['status'];
      this.isActive = _data['isActive'];
      this.createdBy = _data['createdBy'];
      this.createdDate = _data['createdDate'];
      this.modifiedBy = _data['modifiedBy'];
      this.modifiedDate = _data['modifiedDate'];
    }
  }

  static fromJS(data: any): RuleResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RuleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ruleId'] = this.ruleId;
    data['ruleGroupId'] = this.ruleGroupId;
    data['category'] = this.category;
    data['severity'] = this.severity;
    data['name'] = this.name;
    data['whyConflict'] = this.whyConflict;
    data['howToResolve'] = this.howToResolve;
    data['status'] = this.status;
    data['isActive'] = this.isActive;
    data['createdBy'] = this.createdBy;
    data['createdDate'] = this.createdDate;
    data['modifiedBy'] = this.modifiedBy;
    data['modifiedDate'] = this.modifiedDate;
    return data;
  }
}

export interface IRuleResponse {
  ruleId?: number;
  ruleGroupId?: number;
  category?: RuleCategory;
  severity?: RuleSeverity;
  name?: string | undefined;
  whyConflict?: string | undefined;
  howToResolve?: string | undefined;
  status?: string | undefined;
  isActive?: boolean;
  createdBy?: string | undefined;
  createdDate?: string;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
}

export enum RuleSeverity {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class SearchSortParams implements ISearchSortParams {
  searchText?: string | undefined;
  searchColumns?: string[] | undefined;
  sortColumn?: string | undefined;
  sortDirection?: string | undefined;

  constructor(data?: ISearchSortParams) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.searchText = _data['searchText'];
      if (Array.isArray(_data['searchColumns'])) {
        this.searchColumns = [] as any;
        for (let item of _data['searchColumns']) this.searchColumns!.push(item);
      }
      this.sortColumn = _data['sortColumn'];
      this.sortDirection = _data['sortDirection'];
    }
  }

  static fromJS(data: any): SearchSortParams {
    data = typeof data === 'object' ? data : {};
    let result = new SearchSortParams();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['searchText'] = this.searchText;
    if (Array.isArray(this.searchColumns)) {
      data['searchColumns'] = [];
      for (let item of this.searchColumns) data['searchColumns'].push(item);
    }
    data['sortColumn'] = this.sortColumn;
    data['sortDirection'] = this.sortDirection;
    return data;
  }
}

export interface ISearchSortParams {
  searchText?: string | undefined;
  searchColumns?: string[] | undefined;
  sortColumn?: string | undefined;
  sortDirection?: string | undefined;
}

/** Request model for setting the offline PIN for a nurse practitioner. */
export class SetNursePractitionerPinRequest implements ISetNursePractitionerPinRequest {
  /** Gets the offline PIN hash (SHA-256 hex string) to set for the nurse practitioner. */
  pinHash!: string;

  constructor(data?: ISetNursePractitionerPinRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pinHash = _data['pinHash'];
    }
  }

  static fromJS(data: any): SetNursePractitionerPinRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SetNursePractitionerPinRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['pinHash'] = this.pinHash;
    return data;
  }
}

/** Request model for setting the offline PIN for a nurse practitioner. */
export interface ISetNursePractitionerPinRequest {
  /** Gets the offline PIN hash (SHA-256 hex string) to set for the nurse practitioner. */
  pinHash: string;
}

export class SyncRoleActionEntitlementsRequest implements ISyncRoleActionEntitlementsRequest {
  permissionCodes?: string[] | undefined;

  constructor(data?: ISyncRoleActionEntitlementsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['permissionCodes'])) {
        this.permissionCodes = [] as any;
        for (let item of _data['permissionCodes']) this.permissionCodes!.push(item);
      }
    }
  }

  static fromJS(data: any): SyncRoleActionEntitlementsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SyncRoleActionEntitlementsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.permissionCodes)) {
      data['permissionCodes'] = [];
      for (let item of this.permissionCodes) data['permissionCodes'].push(item);
    }
    return data;
  }
}

export interface ISyncRoleActionEntitlementsRequest {
  permissionCodes?: string[] | undefined;
}

export class SyncRoleUsersRequest implements ISyncRoleUsersRequest {
  userIds?: number[] | undefined;

  constructor(data?: ISyncRoleUsersRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['userIds'])) {
        this.userIds = [] as any;
        for (let item of _data['userIds']) this.userIds!.push(item);
      }
    }
  }

  static fromJS(data: any): SyncRoleUsersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SyncRoleUsersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.userIds)) {
      data['userIds'] = [];
      for (let item of this.userIds) data['userIds'].push(item);
    }
    return data;
  }
}

export interface ISyncRoleUsersRequest {
  userIds?: number[] | undefined;
}

export class TriggerClientOnboardingRequest implements ITriggerClientOnboardingRequest {
  clientId?: number;
  clientName?: string | undefined;

  constructor(data?: ITriggerClientOnboardingRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.clientName = _data['clientName'];
    }
  }

  static fromJS(data: any): TriggerClientOnboardingRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TriggerClientOnboardingRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['clientName'] = this.clientName;
    return data;
  }
}

export interface ITriggerClientOnboardingRequest {
  clientId?: number;
  clientName?: string | undefined;
}

export class TriggerClientOnboardingResponse implements ITriggerClientOnboardingResponse {
  releaseId?: number;
  status?: string | undefined;
  databaseName?: string | undefined;
  clientConfigValue?: string | undefined;

  constructor(data?: ITriggerClientOnboardingResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.releaseId = _data['releaseId'];
      this.status = _data['status'];
      this.databaseName = _data['databaseName'];
      this.clientConfigValue = _data['clientConfigValue'];
    }
  }

  static fromJS(data: any): TriggerClientOnboardingResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TriggerClientOnboardingResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['releaseId'] = this.releaseId;
    data['status'] = this.status;
    data['databaseName'] = this.databaseName;
    data['clientConfigValue'] = this.clientConfigValue;
    return data;
  }
}

export interface ITriggerClientOnboardingResponse {
  releaseId?: number;
  status?: string | undefined;
  databaseName?: string | undefined;
  clientConfigValue?: string | undefined;
}

export class UmUserResponse implements IUmUserResponse {
  id?: number;
  userName?: string | undefined;
  emailAddress?: string | undefined;
  isClientUser?: boolean | undefined;
  isActive?: boolean | undefined;
  countryCode?: string | undefined;
  phoneNumber?: string | undefined;

  constructor(data?: IUmUserResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.emailAddress = _data['emailAddress'];
      this.isClientUser = _data['isClientUser'];
      this.isActive = _data['isActive'];
      this.countryCode = _data['countryCode'];
      this.phoneNumber = _data['phoneNumber'];
    }
  }

  static fromJS(data: any): UmUserResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UmUserResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['emailAddress'] = this.emailAddress;
    data['isClientUser'] = this.isClientUser;
    data['isActive'] = this.isActive;
    data['countryCode'] = this.countryCode;
    data['phoneNumber'] = this.phoneNumber;
    return data;
  }
}

export interface IUmUserResponse {
  id?: number;
  userName?: string | undefined;
  emailAddress?: string | undefined;
  isClientUser?: boolean | undefined;
  isActive?: boolean | undefined;
  countryCode?: string | undefined;
  phoneNumber?: string | undefined;
}

export class UnonboardedClientResponse implements IUnonboardedClientResponse {
  clientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;

  constructor(data?: IUnonboardedClientResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.clientName = _data['clientName'];
      this.clientShortName = _data['clientShortName'];
    }
  }

  static fromJS(data: any): UnonboardedClientResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UnonboardedClientResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['clientName'] = this.clientName;
    data['clientShortName'] = this.clientShortName;
    return data;
  }
}

export interface IUnonboardedClientResponse {
  clientId?: number;
  clientName?: string | undefined;
  clientShortName?: string | undefined;
}

export class UpdateClientConfigurationRequest implements IUpdateClientConfigurationRequest {
  clientId?: number;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  vendorIds?: number[] | undefined;

  constructor(data?: IUpdateClientConfigurationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      if (Array.isArray(_data['lobIds'])) {
        this.lobIds = [] as any;
        for (let item of _data['lobIds']) this.lobIds!.push(item);
      }
      if (Array.isArray(_data['interventionTypeIds'])) {
        this.interventionTypeIds = [] as any;
        for (let item of _data['interventionTypeIds']) this.interventionTypeIds!.push(item);
      }
      if (Array.isArray(_data['vendorIds'])) {
        this.vendorIds = [] as any;
        for (let item of _data['vendorIds']) this.vendorIds!.push(item);
      }
    }
  }

  static fromJS(data: any): UpdateClientConfigurationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateClientConfigurationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    if (Array.isArray(this.lobIds)) {
      data['lobIds'] = [];
      for (let item of this.lobIds) data['lobIds'].push(item);
    }
    if (Array.isArray(this.interventionTypeIds)) {
      data['interventionTypeIds'] = [];
      for (let item of this.interventionTypeIds) data['interventionTypeIds'].push(item);
    }
    if (Array.isArray(this.vendorIds)) {
      data['vendorIds'] = [];
      for (let item of this.vendorIds) data['vendorIds'].push(item);
    }
    return data;
  }
}

export interface IUpdateClientConfigurationRequest {
  clientId?: number;
  lobIds?: number[] | undefined;
  interventionTypeIds?: number[] | undefined;
  vendorIds?: number[] | undefined;
}

export class UpdateClientConfigurationResponse implements IUpdateClientConfigurationResponse {
  clientRowId?: number;
  clientId?: number;
  clientName?: string | undefined;
  configurationsDeleted?: number;
  configurationsCreated?: number;

  constructor(data?: IUpdateClientConfigurationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientRowId = _data['clientRowId'];
      this.clientId = _data['clientId'];
      this.clientName = _data['clientName'];
      this.configurationsDeleted = _data['configurationsDeleted'];
      this.configurationsCreated = _data['configurationsCreated'];
    }
  }

  static fromJS(data: any): UpdateClientConfigurationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateClientConfigurationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientRowId'] = this.clientRowId;
    data['clientId'] = this.clientId;
    data['clientName'] = this.clientName;
    data['configurationsDeleted'] = this.configurationsDeleted;
    data['configurationsCreated'] = this.configurationsCreated;
    return data;
  }
}

export interface IUpdateClientConfigurationResponse {
  clientRowId?: number;
  clientId?: number;
  clientName?: string | undefined;
  configurationsDeleted?: number;
  configurationsCreated?: number;
}

export class UpdateReleaseNoteRequest implements IUpdateReleaseNoteRequest {
  releaseName!: string;
  description!: string;
  releaseDate!: string;
  startDate!: string;
  endDate!: string;
  statusId!: number;
  items?: CreateReleaseNoteItemRequest[] | undefined;

  constructor(data?: IUpdateReleaseNoteRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.releaseName = _data['releaseName'];
      this.description = _data['description'];
      this.releaseDate = _data['releaseDate'];
      this.startDate = _data['startDate'];
      this.endDate = _data['endDate'];
      this.statusId = _data['statusId'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CreateReleaseNoteItemRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateReleaseNoteRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateReleaseNoteRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['releaseName'] = this.releaseName;
    data['description'] = this.description;
    data['releaseDate'] = this.releaseDate;
    data['startDate'] = this.startDate;
    data['endDate'] = this.endDate;
    data['statusId'] = this.statusId;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IUpdateReleaseNoteRequest {
  releaseName: string;
  description: string;
  releaseDate: string;
  startDate: string;
  endDate: string;
  statusId: number;
  items?: CreateReleaseNoteItemRequest[] | undefined;
}

export class UpdateRuleGroupRequest implements IUpdateRuleGroupRequest {
  name!: string;
  description?: string | undefined;
  isActive?: boolean;

  constructor(data?: IUpdateRuleGroupRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.description = _data['description'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): UpdateRuleGroupRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateRuleGroupRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IUpdateRuleGroupRequest {
  name: string;
  description?: string | undefined;
  isActive?: boolean;
}

export class UserActionEntitlementCreateRequest implements IUserActionEntitlementCreateRequest {
  userId!: number;
  code!: string;
  notAllowed?: boolean | undefined;

  constructor(data?: IUserActionEntitlementCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.code = _data['code'];
      this.notAllowed = _data['notAllowed'];
    }
  }

  static fromJS(data: any): UserActionEntitlementCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserActionEntitlementCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['code'] = this.code;
    data['notAllowed'] = this.notAllowed;
    return data;
  }
}

export interface IUserActionEntitlementCreateRequest {
  userId: number;
  code: string;
  notAllowed?: boolean | undefined;
}

export class UserActionEntitlementResponse implements IUserActionEntitlementResponse {
  id?: number;
  userId?: number | undefined;
  code?: string | undefined;
  notAllowed?: boolean | undefined;

  constructor(data?: IUserActionEntitlementResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userId = _data['userId'];
      this.code = _data['code'];
      this.notAllowed = _data['notAllowed'];
    }
  }

  static fromJS(data: any): UserActionEntitlementResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserActionEntitlementResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userId'] = this.userId;
    data['code'] = this.code;
    data['notAllowed'] = this.notAllowed;
    return data;
  }
}

export interface IUserActionEntitlementResponse {
  id?: number;
  userId?: number | undefined;
  code?: string | undefined;
  notAllowed?: boolean | undefined;
}

export class UserActionEntitlementResultResponse implements IUserActionEntitlementResultResponse {
  code?: string | undefined;
  actionEntitlementGroup?: string | undefined;
  parentGroupId?: number | undefined;
  notAllowed?: boolean;
  hierarchy?: string | undefined;
  hierarchyLayer?: number;

  constructor(data?: IUserActionEntitlementResultResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data['code'];
      this.actionEntitlementGroup = _data['actionEntitlementGroup'];
      this.parentGroupId = _data['parentGroupId'];
      this.notAllowed = _data['notAllowed'];
      this.hierarchy = _data['hierarchy'];
      this.hierarchyLayer = _data['hierarchyLayer'];
    }
  }

  static fromJS(data: any): UserActionEntitlementResultResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserActionEntitlementResultResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['actionEntitlementGroup'] = this.actionEntitlementGroup;
    data['parentGroupId'] = this.parentGroupId;
    data['notAllowed'] = this.notAllowed;
    data['hierarchy'] = this.hierarchy;
    data['hierarchyLayer'] = this.hierarchyLayer;
    return data;
  }
}

export interface IUserActionEntitlementResultResponse {
  code?: string | undefined;
  actionEntitlementGroup?: string | undefined;
  parentGroupId?: number | undefined;
  notAllowed?: boolean;
  hierarchy?: string | undefined;
  hierarchyLayer?: number;
}

export class UserAssignmentDetailResponse implements IUserAssignmentDetailResponse {
  userId?: number;
  rolesAdded?: number;
  rolesAlreadyAssigned?: number;
  error?: string | undefined;

  constructor(data?: IUserAssignmentDetailResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.rolesAdded = _data['rolesAdded'];
      this.rolesAlreadyAssigned = _data['rolesAlreadyAssigned'];
      this.error = _data['error'];
    }
  }

  static fromJS(data: any): UserAssignmentDetailResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserAssignmentDetailResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['rolesAdded'] = this.rolesAdded;
    data['rolesAlreadyAssigned'] = this.rolesAlreadyAssigned;
    data['error'] = this.error;
    return data;
  }
}

export interface IUserAssignmentDetailResponse {
  userId?: number;
  rolesAdded?: number;
  rolesAlreadyAssigned?: number;
  error?: string | undefined;
}

export class UserCreateRequest implements IUserCreateRequest {
  firstName!: string;
  lastName?: string | undefined;
  emailAddress!: string;
  isClientUser!: boolean;
  phoneNumber?: string | undefined;
  userTypeId!: number;
  vendorIds!: number[];
  roleIds!: number[];
  npi?: string | undefined;

  constructor(data?: IUserCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.vendorIds = [];
      this.roleIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.emailAddress = _data['emailAddress'];
      this.isClientUser = _data['isClientUser'];
      this.phoneNumber = _data['phoneNumber'];
      this.userTypeId = _data['userTypeId'];
      if (Array.isArray(_data['vendorIds'])) {
        this.vendorIds = [] as any;
        for (let item of _data['vendorIds']) this.vendorIds!.push(item);
      }
      if (Array.isArray(_data['roleIds'])) {
        this.roleIds = [] as any;
        for (let item of _data['roleIds']) this.roleIds!.push(item);
      }
      this.npi = _data['npi'];
    }
  }

  static fromJS(data: any): UserCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['emailAddress'] = this.emailAddress;
    data['isClientUser'] = this.isClientUser;
    data['phoneNumber'] = this.phoneNumber;
    data['userTypeId'] = this.userTypeId;
    if (Array.isArray(this.vendorIds)) {
      data['vendorIds'] = [];
      for (let item of this.vendorIds) data['vendorIds'].push(item);
    }
    if (Array.isArray(this.roleIds)) {
      data['roleIds'] = [];
      for (let item of this.roleIds) data['roleIds'].push(item);
    }
    data['npi'] = this.npi;
    return data;
  }
}

export interface IUserCreateRequest {
  firstName: string;
  lastName?: string | undefined;
  emailAddress: string;
  isClientUser: boolean;
  phoneNumber?: string | undefined;
  userTypeId: number;
  vendorIds: number[];
  roleIds: number[];
  npi?: string | undefined;
}

export class UserCreateResponse implements IUserCreateResponse {
  userManagementUserId?: number;
  centralUserId?: number | undefined;
  userName!: string | undefined;
  emailAddress!: string | undefined;
  phoneNumber?: string | undefined;
  isClientUser?: boolean;
  userTypeId?: number;
  roleIds?: number[] | undefined;
  practitionerId?: number | undefined;

  constructor(data?: IUserCreateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userManagementUserId = _data['userManagementUserId'];
      this.centralUserId = _data['centralUserId'];
      this.userName = _data['userName'];
      this.emailAddress = _data['emailAddress'];
      this.phoneNumber = _data['phoneNumber'];
      this.isClientUser = _data['isClientUser'];
      this.userTypeId = _data['userTypeId'];
      if (Array.isArray(_data['roleIds'])) {
        this.roleIds = [] as any;
        for (let item of _data['roleIds']) this.roleIds!.push(item);
      }
      this.practitionerId = _data['practitionerId'];
    }
  }

  static fromJS(data: any): UserCreateResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserCreateResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userManagementUserId'] = this.userManagementUserId;
    data['centralUserId'] = this.centralUserId;
    data['userName'] = this.userName;
    data['emailAddress'] = this.emailAddress;
    data['phoneNumber'] = this.phoneNumber;
    data['isClientUser'] = this.isClientUser;
    data['userTypeId'] = this.userTypeId;
    if (Array.isArray(this.roleIds)) {
      data['roleIds'] = [];
      for (let item of this.roleIds) data['roleIds'].push(item);
    }
    data['practitionerId'] = this.practitionerId;
    return data;
  }
}

export interface IUserCreateResponse {
  userManagementUserId?: number;
  centralUserId?: number | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  phoneNumber?: string | undefined;
  isClientUser?: boolean;
  userTypeId?: number;
  roleIds?: number[] | undefined;
  practitionerId?: number | undefined;
}

export class UserDetailByIdResponse implements IUserDetailByIdResponse {
  id?: number;
  userName?: string | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isActive?: boolean | undefined;
  shortName?: string | undefined;
  fullName?: string | undefined;
  clientId?: number | undefined;
  rolesId?: string | undefined;
  applicationsId?: string | undefined;
  applicationId?: number | undefined;

  constructor(data?: IUserDetailByIdResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.phoneNumber = _data['phoneNumber'];
      this.emailAddress = _data['emailAddress'];
      this.isActive = _data['isActive'];
      this.shortName = _data['shortName'];
      this.fullName = _data['fullName'];
      this.clientId = _data['clientId'];
      this.rolesId = _data['rolesId'];
      this.applicationsId = _data['applicationsId'];
      this.applicationId = _data['applicationId'];
    }
  }

  static fromJS(data: any): UserDetailByIdResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserDetailByIdResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['phoneNumber'] = this.phoneNumber;
    data['emailAddress'] = this.emailAddress;
    data['isActive'] = this.isActive;
    data['shortName'] = this.shortName;
    data['fullName'] = this.fullName;
    data['clientId'] = this.clientId;
    data['rolesId'] = this.rolesId;
    data['applicationsId'] = this.applicationsId;
    data['applicationId'] = this.applicationId;
    return data;
  }
}

export interface IUserDetailByIdResponse {
  id?: number;
  userName?: string | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isActive?: boolean | undefined;
  shortName?: string | undefined;
  fullName?: string | undefined;
  clientId?: number | undefined;
  rolesId?: string | undefined;
  applicationsId?: string | undefined;
  applicationId?: number | undefined;
}

export class UserDetailResponse implements IUserDetailResponse {
  id?: number;
  userName?: string | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isActive?: boolean | undefined;
  clientId?: number | undefined;
  isPrimary?: boolean | undefined;
  activationStatus?: boolean | undefined;
  redeemStatus?: boolean | undefined;
  shortName?: string | undefined;
  fullName?: string | undefined;
  applicationRoleId?: number | undefined;
  applicationId?: number | undefined;
  applicationIdOfRoleId?: number | undefined;
  applicationShortName?: string | undefined;

  constructor(data?: IUserDetailResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.phoneNumber = _data['phoneNumber'];
      this.emailAddress = _data['emailAddress'];
      this.isActive = _data['isActive'];
      this.clientId = _data['clientId'];
      this.isPrimary = _data['isPrimary'];
      this.activationStatus = _data['activationStatus'];
      this.redeemStatus = _data['redeemStatus'];
      this.shortName = _data['shortName'];
      this.fullName = _data['fullName'];
      this.applicationRoleId = _data['applicationRoleId'];
      this.applicationId = _data['applicationId'];
      this.applicationIdOfRoleId = _data['applicationIdOfRoleId'];
      this.applicationShortName = _data['applicationShortName'];
    }
  }

  static fromJS(data: any): UserDetailResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserDetailResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['phoneNumber'] = this.phoneNumber;
    data['emailAddress'] = this.emailAddress;
    data['isActive'] = this.isActive;
    data['clientId'] = this.clientId;
    data['isPrimary'] = this.isPrimary;
    data['activationStatus'] = this.activationStatus;
    data['redeemStatus'] = this.redeemStatus;
    data['shortName'] = this.shortName;
    data['fullName'] = this.fullName;
    data['applicationRoleId'] = this.applicationRoleId;
    data['applicationId'] = this.applicationId;
    data['applicationIdOfRoleId'] = this.applicationIdOfRoleId;
    data['applicationShortName'] = this.applicationShortName;
    return data;
  }
}

export interface IUserDetailResponse {
  id?: number;
  userName?: string | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isActive?: boolean | undefined;
  clientId?: number | undefined;
  isPrimary?: boolean | undefined;
  activationStatus?: boolean | undefined;
  redeemStatus?: boolean | undefined;
  shortName?: string | undefined;
  fullName?: string | undefined;
  applicationRoleId?: number | undefined;
  applicationId?: number | undefined;
  applicationIdOfRoleId?: number | undefined;
  applicationShortName?: string | undefined;
}

export class UserListItemResponse implements IUserListItemResponse {
  id?: number;
  userManagementUserId?: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  status?: string | undefined;
  userTypeId?: number | undefined;
  vendorIds?: number[] | undefined;
  npi?: string | undefined;
  sourceSystem?: string | undefined;
  roles?: RoleItemResponse[] | undefined;

  constructor(data?: IUserListItemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userManagementUserId = _data['userManagementUserId'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.phoneNumber = _data['phoneNumber'];
      this.emailAddress = _data['emailAddress'];
      this.status = _data['status'];
      this.userTypeId = _data['userTypeId'];
      if (Array.isArray(_data['vendorIds'])) {
        this.vendorIds = [] as any;
        for (let item of _data['vendorIds']) this.vendorIds!.push(item);
      }
      this.npi = _data['npi'];
      this.sourceSystem = _data['sourceSystem'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles']) this.roles!.push(RoleItemResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserListItemResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserListItemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userManagementUserId'] = this.userManagementUserId;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['phoneNumber'] = this.phoneNumber;
    data['emailAddress'] = this.emailAddress;
    data['status'] = this.status;
    data['userTypeId'] = this.userTypeId;
    if (Array.isArray(this.vendorIds)) {
      data['vendorIds'] = [];
      for (let item of this.vendorIds) data['vendorIds'].push(item);
    }
    data['npi'] = this.npi;
    data['sourceSystem'] = this.sourceSystem;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IUserListItemResponse {
  id?: number;
  userManagementUserId?: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  status?: string | undefined;
  userTypeId?: number | undefined;
  vendorIds?: number[] | undefined;
  npi?: string | undefined;
  sourceSystem?: string | undefined;
  roles?: RoleItemResponse[] | undefined;
}

export class UserListItemResponsePagedResult implements IUserListItemResponsePagedResult {
  items?: UserListItemResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IUserListItemResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(UserListItemResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): UserListItemResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new UserListItemResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IUserListItemResponsePagedResult {
  items?: UserListItemResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class UserListRequest implements IUserListRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  searchSort?: SearchSortParams;
  roleName?: string[] | undefined;
  status?: string | undefined;
  userTypeId?: number | undefined;
  roleIdToExcludeUsers?: number | undefined;
  paginationRequired?: boolean;

  constructor(data?: IUserListRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      if (Array.isArray(_data['roleName'])) {
        this.roleName = [] as any;
        for (let item of _data['roleName']) this.roleName!.push(item);
      }
      this.status = _data['status'];
      this.userTypeId = _data['userTypeId'];
      this.roleIdToExcludeUsers = _data['roleIdToExcludeUsers'];
      this.paginationRequired = _data['paginationRequired'];
    }
  }

  static fromJS(data: any): UserListRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserListRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    if (Array.isArray(this.roleName)) {
      data['roleName'] = [];
      for (let item of this.roleName) data['roleName'].push(item);
    }
    data['status'] = this.status;
    data['userTypeId'] = this.userTypeId;
    data['roleIdToExcludeUsers'] = this.roleIdToExcludeUsers;
    data['paginationRequired'] = this.paginationRequired;
    return data;
  }
}

export interface IUserListRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  searchSort?: SearchSortParams;
  roleName?: string[] | undefined;
  status?: string | undefined;
  userTypeId?: number | undefined;
  roleIdToExcludeUsers?: number | undefined;
  paginationRequired?: boolean;
}

export class UserResponse implements IUserResponse {
  id?: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  emailAddress?: string | undefined;
  isClientUser?: boolean | undefined;
  isActive?: boolean | undefined;
  countryCode?: string | undefined;
  phoneNumber?: string | undefined;

  constructor(data?: IUserResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.emailAddress = _data['emailAddress'];
      this.isClientUser = _data['isClientUser'];
      this.isActive = _data['isActive'];
      this.countryCode = _data['countryCode'];
      this.phoneNumber = _data['phoneNumber'];
    }
  }

  static fromJS(data: any): UserResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['emailAddress'] = this.emailAddress;
    data['isClientUser'] = this.isClientUser;
    data['isActive'] = this.isActive;
    data['countryCode'] = this.countryCode;
    data['phoneNumber'] = this.phoneNumber;
    return data;
  }
}

export interface IUserResponse {
  id?: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  emailAddress?: string | undefined;
  isClientUser?: boolean | undefined;
  isActive?: boolean | undefined;
  countryCode?: string | undefined;
  phoneNumber?: string | undefined;
}

export class UserRoleCreateRequest implements IUserRoleCreateRequest {
  userId?: number;
  applicationRoleId!: number;
  isActive?: boolean | undefined;

  constructor(data?: IUserRoleCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.applicationRoleId = _data['applicationRoleId'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): UserRoleCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserRoleCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['applicationRoleId'] = this.applicationRoleId;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IUserRoleCreateRequest {
  userId?: number;
  applicationRoleId: number;
  isActive?: boolean | undefined;
}

export class UserRoleResponse implements IUserRoleResponse {
  id?: number;
  userId?: number;
  applicationRoleId?: number | undefined;
  isActive?: boolean | undefined;

  constructor(data?: IUserRoleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userId = _data['userId'];
      this.applicationRoleId = _data['applicationRoleId'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): UserRoleResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserRoleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userId'] = this.userId;
    data['applicationRoleId'] = this.applicationRoleId;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IUserRoleResponse {
  id?: number;
  userId?: number;
  applicationRoleId?: number | undefined;
  isActive?: boolean | undefined;
}

export class UserRolesDetailByIdResponse implements IUserRolesDetailByIdResponse {
  id?: number;
  userName?: string | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isActive?: boolean | undefined;
  shortName?: string | undefined;
  fullName?: string | undefined;
  clientId?: number | undefined;
  rolesId?: string | undefined;
  applicationsId?: string | undefined;
  applicationId?: number | undefined;

  constructor(data?: IUserRolesDetailByIdResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.phoneNumber = _data['phoneNumber'];
      this.emailAddress = _data['emailAddress'];
      this.isActive = _data['isActive'];
      this.shortName = _data['shortName'];
      this.fullName = _data['fullName'];
      this.clientId = _data['clientId'];
      this.rolesId = _data['rolesId'];
      this.applicationsId = _data['applicationsId'];
      this.applicationId = _data['applicationId'];
    }
  }

  static fromJS(data: any): UserRolesDetailByIdResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserRolesDetailByIdResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['phoneNumber'] = this.phoneNumber;
    data['emailAddress'] = this.emailAddress;
    data['isActive'] = this.isActive;
    data['shortName'] = this.shortName;
    data['fullName'] = this.fullName;
    data['clientId'] = this.clientId;
    data['rolesId'] = this.rolesId;
    data['applicationsId'] = this.applicationsId;
    data['applicationId'] = this.applicationId;
    return data;
  }
}

export interface IUserRolesDetailByIdResponse {
  id?: number;
  userName?: string | undefined;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isActive?: boolean | undefined;
  shortName?: string | undefined;
  fullName?: string | undefined;
  clientId?: number | undefined;
  rolesId?: string | undefined;
  applicationsId?: string | undefined;
  applicationId?: number | undefined;
}

export class UserSearchRequest implements IUserSearchRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  searchSort?: SearchSortParams;
  userTypeId?: number | undefined;
  vendorId?: number | undefined;
  includeInactive?: boolean;
  isClientUser?: boolean | undefined;

  constructor(data?: IUserSearchRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      this.userTypeId = _data['userTypeId'];
      this.vendorId = _data['vendorId'];
      this.includeInactive = _data['includeInactive'];
      this.isClientUser = _data['isClientUser'];
    }
  }

  static fromJS(data: any): UserSearchRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserSearchRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    data['userTypeId'] = this.userTypeId;
    data['vendorId'] = this.vendorId;
    data['includeInactive'] = this.includeInactive;
    data['isClientUser'] = this.isClientUser;
    return data;
  }
}

export interface IUserSearchRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  searchSort?: SearchSortParams;
  userTypeId?: number | undefined;
  vendorId?: number | undefined;
  includeInactive?: boolean;
  isClientUser?: boolean | undefined;
}

export class UserSearchResponse implements IUserSearchResponse {
  userId?: number;
  userName?: string | undefined;
  emailAddress?: string | undefined;
  userTypeId?: number;

  constructor(data?: IUserSearchResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.userName = _data['userName'];
      this.emailAddress = _data['emailAddress'];
      this.userTypeId = _data['userTypeId'];
    }
  }

  static fromJS(data: any): UserSearchResponse {
    data = typeof data === 'object' ? data : {};
    let result = new UserSearchResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['userName'] = this.userName;
    data['emailAddress'] = this.emailAddress;
    data['userTypeId'] = this.userTypeId;
    return data;
  }
}

export interface IUserSearchResponse {
  userId?: number;
  userName?: string | undefined;
  emailAddress?: string | undefined;
  userTypeId?: number;
}

export class UserSearchResponsePagedResult implements IUserSearchResponsePagedResult {
  items?: UserSearchResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IUserSearchResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(UserSearchResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): UserSearchResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new UserSearchResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IUserSearchResponsePagedResult {
  items?: UserSearchResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class UserUpdateRequest implements IUserUpdateRequest {
  id!: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phoneNumber?: string | undefined;
  vendorIds!: number[];
  userType?: number | undefined;
  roleIds?: number[] | undefined;
  npi?: string | undefined;

  constructor(data?: IUserUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.vendorIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.phoneNumber = _data['phoneNumber'];
      if (Array.isArray(_data['vendorIds'])) {
        this.vendorIds = [] as any;
        for (let item of _data['vendorIds']) this.vendorIds!.push(item);
      }
      this.userType = _data['userType'];
      if (Array.isArray(_data['roleIds'])) {
        this.roleIds = [] as any;
        for (let item of _data['roleIds']) this.roleIds!.push(item);
      }
      this.npi = _data['npi'];
    }
  }

  static fromJS(data: any): UserUpdateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['phoneNumber'] = this.phoneNumber;
    if (Array.isArray(this.vendorIds)) {
      data['vendorIds'] = [];
      for (let item of this.vendorIds) data['vendorIds'].push(item);
    }
    data['userType'] = this.userType;
    if (Array.isArray(this.roleIds)) {
      data['roleIds'] = [];
      for (let item of this.roleIds) data['roleIds'].push(item);
    }
    data['npi'] = this.npi;
    return data;
  }
}

export interface IUserUpdateRequest {
  id: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phoneNumber?: string | undefined;
  vendorIds: number[];
  userType?: number | undefined;
  roleIds?: number[] | undefined;
  npi?: string | undefined;
}

export class VendorDto implements IVendorDto {
  vendorId?: number;
  vendorCode?: string | undefined;
  vendorName?: string | undefined;
  isActive?: boolean;

  constructor(data?: IVendorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.vendorId = _data['vendorId'];
      this.vendorCode = _data['vendorCode'];
      this.vendorName = _data['vendorName'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): VendorDto {
    data = typeof data === 'object' ? data : {};
    let result = new VendorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['vendorId'] = this.vendorId;
    data['vendorCode'] = this.vendorCode;
    data['vendorName'] = this.vendorName;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IVendorDto {
  vendorId?: number;
  vendorCode?: string | undefined;
  vendorName?: string | undefined;
  isActive?: boolean;
}

export class VendorUsersByTypeRequest implements IVendorUsersByTypeRequest {
  userTypeIds!: number[] | undefined;
  vendorId?: number;

  constructor(data?: IVendorUsersByTypeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['userTypeIds'])) {
        this.userTypeIds = [] as any;
        for (let item of _data['userTypeIds']) this.userTypeIds!.push(item);
      }
      this.vendorId = _data['vendorId'];
    }
  }

  static fromJS(data: any): VendorUsersByTypeRequest {
    data = typeof data === 'object' ? data : {};
    let result = new VendorUsersByTypeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.userTypeIds)) {
      data['userTypeIds'] = [];
      for (let item of this.userTypeIds) data['userTypeIds'].push(item);
    }
    data['vendorId'] = this.vendorId;
    return data;
  }
}

export interface IVendorUsersByTypeRequest {
  userTypeIds: number[] | undefined;
  vendorId?: number;
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
